import React, { useEffect, useState } from "react";
import { useTheme } from '../ThemeContext';
import { Cpu, Key, X, Layers, CloudDrizzle, CloudLightning, Wind, Cloud, Sun } from 'react-feather';
import getModelDate from "../../MongoDb/GetModelDate";
import getTodaysBets from "../../MongoDb/GetBets";
import getModel from "../../MongoDb/GetModel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './Schedule.css';
import StatsMatch from "../stats";
import '../shared/PageHeader.css';
import * as Realm from "realm-web";
import { min, parse, set } from "date-fns";
const app = new Realm.App({ id: "thebrainfund-qyrogsg" });

// Inline AdSense Component
const AdSenseAd = ({ slot, style = { width: '100%', height: '10px' } }) => {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  return (
    <div className="adsense-container2">
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client="ca-pub-7565792583009117" // Replace with your actual publisher ID
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default function Model() {
  const { isDarkMode } = useTheme();
  const footballstart = '2025-09-02';
  const year = "2025";
  const startOfWeek1 = new Date(new Date(footballstart).setDate(new Date(footballstart).getDate() + 1));
  const today = new Date();
  const currentWeekNumber = Math.floor((today - startOfWeek1) / (7 * 24 * 60 * 60 * 1000)) + 1;
  const [analysisLoading, setAnalysisLoading] = useState(false);
  const [analysisOutput, setAnalysisOutput] = useState("");
  const [showHistoricRecord, setShowHistoricRecord] = useState(false);
  const [loading, setLoading] = useState(false);
  const [similarLoading, setSimilarLoading] = useState(false);
  const validStatuses = ["FT", "AOT", "AP", "AET"];

  // Situation Analysis state
  const [showSituationAnalysis, setShowSituationAnalysis] = useState(false);
  const [situationAnalysisData, setSituationAnalysisData] = useState(null);

  const [activeBets, setActiveBets] = useState([]);

  useEffect(() => {
    const fetchActiveBets = async () => {
      try {
        const bets = await getTodaysBets();
        setActiveBets(bets);
      } catch (error) {
        console.error('Failed to get today bets:', error);
      }
    };
    fetchActiveBets();
  }, []);
  // Run Line Calculator state
  const [showRunLineCalculator, setShowRunLineCalculator] = useState(false);
  const [runLineData, setRunLineData] = useState({
    amount: '',
    moneyline: '',
    runline: ''
  });

  // Add state for parlay calculator
  const [showParlayCalculator, setShowParlayCalculator] = useState(false);
  const [parlayOdds, setParlayOdds] = useState(["", "", ""]); // Default 3 odds
  const [impactWeights, setImpactWeights] = useState({
    stats: 50,
    location: 50,
    weather: 50,
    injury: 50,
    convictionLimit: 100
  });

  const [similarGames, setSimilarGames] = useState([]);
  const [considerOpponent, setConsiderOpponent] = useState(false);


  useEffect(() => {
    if (situationAnalysisData && showSituationAnalysis) {
      setSimilarLoading(true);
      getSimilarSituationGames()
        .then(games => setSimilarGames(games))
        .finally(() => setSimilarLoading(false));
    }
  }, [situationAnalysisData, showSituationAnalysis]);

  // // Then in your table:
  // <tbody>
  //   {similarGames.map((game, idx) => (
  //     <tr key={idx}>
  //       <td>{game.Date}</td>
  //       <td>{game.Home}</td>
  //       <td>{game.Away}</td>
  //       <td>{game.score_x || 'N/A'}</td>
  //       <td>{game.score_y || 'N/A'}</td>
  //       <td>{game.Spread_home || 'N/A'}</td>
  //       <td>{game["O/U"] || 'N/A'}</td>
  //     </tr>
  //   ))}
  // </tbody>

  const handleSliderChange = (sliderName, value) => {
    setImpactWeights(prev => ({
      ...prev,
      [sliderName]: parseInt(value)
    }));
  };

  // Handler to update odds
  const handleParlayOddsChange = (idx, value) => {
    const newOdds = [...parlayOdds];
    newOdds[idx] = value;
    setParlayOdds(newOdds);
  };

  // Handler to add more odds
  const addParlayLeg = () => setParlayOdds([...parlayOdds, ""]);

  // Calculate implied parlay odds
  const calcParlayImpliedOdds = (oddsArr) => {
    // Convert American odds to implied probability
    const probs = oddsArr
      .map(o => parseFloat(o))
      .filter(o => !isNaN(o))
      .map(o => (o > 0 ? 100 / (o + 100) : Math.abs(o) / (Math.abs(o) + 100)));
    if (probs.length === 0) return null;
    const parlayProb = probs.reduce((acc, p) => acc * p, 1);
    // Convert back to American odds
    const decimal = 1 / parlayProb;
    const american = decimal >= 2
      ? Math.round((decimal - 1) * 100)
      : Math.round(-100 / (decimal - 1));
    return { impliedProb: (parlayProb * 100).toFixed(2), american };
  };

  const handleParlayRefresh = () => {
    setParlayOdds(["", "", ""]);
  };
  const Loader = () => (
    <div className="loader"></div>
  );
  
  const getHomeAdv = (sport) => {
    if (sport === "NFL") {return 2.2;}
    if (sport === "CFB") {return 2.4;}
    if (sport === "NBA") {return 2.5;}
    if (sport === "CBB") {return 3.3;}
    if (sport === "MLB") {return 0.3;}
    if (sport === "NHL") {return 0.3;}
    if (sport === "Soccer") {return 0.2;}
  }

  const handleCloseSituationAnalysis = () => {
    setShowSituationAnalysis(false);
    setSimilarGames([]);
    setSimilarLoading(false);
  };

  const hasActiveBet = (game, activeBets) => {
    if (!activeBets || activeBets.length === 0) return false;
    if (!game || !game.Date || !game.Home || !game.Away) return false;
    
    try {
      // Convert game.date (MM/DD/YYYY) to YYYY-MM-DD format
      const gameDateParts = game.Date.split('/');
      if (gameDateParts.length !== 3) return false;
      
      const normalizedGameDate = `${gameDateParts[2]}-${gameDateParts[0]}-${gameDateParts[1]}`;
      
      return activeBets.some(bet => 
        bet && 
        bet.Bet_Team && 
        bet.Bet_Date &&
        (bet.Bet_Team === game.Home || bet.Bet_Team === game.Away) &&
        bet.Bet_Date === normalizedGameDate
      );
    } catch (error) {
      console.error('Error in hasActiveBet:', error);
      return false;
    }
  };

  const [model, setModel] = useState({
    allBets: [],
    nflBets: [],
    cfbBets: [],
    nbaBets: [],
    cbbBets: [],
    nhlBets: [],
    mlbBets: [],
    soccerBets: [],
  });

  const [expandedGames, setExpandedGames] = useState({
    NFL: null,
    CFB: null,
    NBA: null,
    CBB: null,
    NHL: null,
    MLB: null,
    Soccer: null,
  });

  const [collapsedSections, setCollapsedSections] = useState({
    NFL: false,
    CFB: false,
    NBA: false,
    CBB: false,
    NHL: false,
    MLB: false,
    Soccer: false,
  });

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [historicRecord, setHistoricRecord] = useState({ wins: 0, losses: 0, pushes: 0 });

  useEffect(() => {
    let totalWins = 0;
    let totalLosses = 0;
    let totalPushes = 0;

    Object.keys(model).forEach(key => {
      if (key.includes('Bets')) {
        const bets = model[key];
        bets.forEach(game => {
          const validStatuses = ["FT", "AOT", "AP", "AET"];
          const awayScore = parseFloat(game.score_y) || 0;
          const homeScore = parseFloat(game.score_x) || 0;
          const spread = parseFloat(game.Spread_home) || 0;
          let total = parseFloat(game["O/U"]) || 0;
          if (game.Sport === "Soccer") {
            total = 2.5;
          }
          
          const isValidGame = validStatuses.includes(game.status) && (homeScore !== 0 || awayScore !== 0);
          
          if (!isValidGame) return;
          
          // Check home team winner/loser
          const homeWinner = parseFloat(game.Value_Home) > 0 && (
            spread >= 0
              ? (homeScore + spread) > awayScore
              : (homeScore - Math.abs(spread)) > awayScore
          );
          
          const homeLoser = parseFloat(game.Value_Home) > 0 && (
            spread >= 0
              ? (homeScore + spread) < awayScore
              : (homeScore - Math.abs(spread)) < awayScore
          );
          
          // Check away team winner/loser
          const awayWinner = parseFloat(game.Value_Away) > 0 && (
            spread < 0
              ? spread < (awayScore - homeScore)
              : Math.abs(spread) < (awayScore - homeScore)
          );
          
          const awayLoser = parseFloat(game.Value_Away) > 0 && (
            spread < 0 
              ? spread > (awayScore - homeScore) 
              : Math.abs(spread) > (awayScore - homeScore)
          );
          
          // Check over/under winners/losers
          const projTotal = typeof game.Proj_Total === 'string' ? game.Proj_Total : '';
          const overWinner = projTotal.includes("Over") && (awayScore + homeScore) > total;
          const overLoser = projTotal.includes("Over") && (awayScore + homeScore) < total;
          const underWinner = projTotal.includes("Under") && (awayScore + homeScore) < total;
          const underLoser = projTotal.includes("Under") && (awayScore + homeScore) > total;
          
          // Count each bet individually
          if (parseFloat(game.Value_Home) > 0) {
            if (homeWinner) totalWins++;
            else if (homeLoser) totalLosses++;
            else totalPushes++;
          }
          if (parseFloat(game.Value_Away) > 0) {
            if (awayWinner) totalWins++;
            else if (awayLoser) totalLosses++;
            else totalPushes++;
          }
          if (projTotal.includes("Over")) {
            if (overWinner) totalWins++;
            else if (overLoser) totalLosses++;
            else totalPushes++;
          }
          if (projTotal.includes("Under")) {
            if (underWinner) totalWins++;
            else if (underLoser) totalLosses++;
            else totalPushes++;
          }
        });
      }
    });

    setHistoricRecord({ wins: totalWins, losses: totalLosses, pushes: totalPushes });
  }, [model]);

  const reformatDate = (date_str) => {
    const date = new Date(date_str); // Parse the input date string into a Date object
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Get the month, add 1 (since months are 0-based), and format it to 2 digits
    const day = ('0' + date.getDate()).slice(-2); // Get the day, format it to 2 digits
    const year = date.getFullYear(); // Get the year
    return `${month}-${day}-${year}`; // Return the formatted date
  };

  
  
  useEffect(() => {
    const formatDate = (date) => {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = String(date.getFullYear()).slice(-2);
      return `${month}/${day}/${year}`;
    };

    const fetchModelData = async () => {
      try {
        setLoading(true);
        const bets = await getModelDate(reformatDate(selectedDate));
        const sortedBets = bets.sort((a, b) => new Date(a.Time) - new Date(b.Time));
        setLoading(false);
        const filteredBets = sortedBets.filter(item => {
          const betDate = new Date(item.Time);
          return formatDate(betDate) === formatDate(selectedDate);


        });

        setModel({
          allBets: filteredBets,
          nflBets: filteredBets.filter(item => item.Sport === "NFL"),
          cfbBets: filteredBets.filter(item => item.Sport === "CFB"),
          nbaBets: filteredBets.filter(item => item.Sport === "NBA"),
          cbbBets: filteredBets.filter(item => item.Sport === "CBB"),
          nhlBets: filteredBets.filter(item => item.Sport === "NHL"),
          mlbBets: filteredBets.filter(item => item.Sport === "MLB"),
          soccerBets: filteredBets.filter(item => item.Sport === "Soccer"),
        });
      } catch (error) {
        console.error('Failed to get model data:', error);
      }
    };

    fetchModelData();
  }, [selectedDate]);  // Re-fetch data when the selected date changes

  const getAdjustedProjections = (item) => {
    const sport = (item.Sport || "").toUpperCase();
    const baseHomeProj = parseFloat(item.Home_Proj) || 0;
    const baseAwayProj = parseFloat(item.Away_Proj) || 0;

    const adj_weather = parseFloat(item.adj_weather) || 0.0;

    const qb_injury_home = parseFloat(item.QB_Injury_DYAR?.['x']) || 0.0;
    const wr_injury_home = parseFloat(item.WR_Injury_DYAR?.['x']) || 0.0; 
    const rb_injury_home = parseFloat(item.RB_Injury_DYAR?.['x']) || 0.0; 
    let adj_injury_home = qb_injury_home + wr_injury_home + rb_injury_home;
  
    const qb_injury_away = parseFloat(item.QB_Injury_DYAR?.['y']) || 0.0;
    const wr_injury_away = parseFloat(item.WR_Injury_DYAR?.['y']) || 0.0; 
    const rb_injury_away = parseFloat(item.RB_Injury_DYAR?.['y']) || 0.0; 
    let adj_injury_away = qb_injury_away + wr_injury_away + rb_injury_away;

    if (sport === "NFL" || sport === "CFB") {
      adj_injury_home *= 0.2;
      adj_injury_away *= 0.2;
    }

    const ptsKey = getLatestPtsKey(item, "pts") || `${year}_pts`;
    const ptsObj = item[ptsKey] || {};
    const pts_for_home = parseFloat(ptsObj["for_x"])
    const pts_for_away = parseFloat(ptsObj["for_y"])

    // Calculate adjustment multiplier based on impact weights
    // Sliders range from 0-100, convert to 0.5-1.5 multiplier range
    let statsWeight = (Math.abs(impactWeights.stats)) * 0.01;
    let locationMultiplier = (impactWeights.location - 50) * 0.01 * getHomeAdv(item.Sport);
    let weatherMultiplier = (impactWeights.weather - 50) * 0.01 * adj_weather;
    let injuryMultiplier_home = ((-impactWeights.injury - 50) * 0.005) * adj_injury_home;
    let injuryMultiplier_away = ((-impactWeights.injury - 50) * 0.005) * adj_injury_away;
    
    if (impactWeights.stats === 50) {
      statsWeight = 0;
    }
    if (impactWeights.location === 50) {
      locationMultiplier = 0;
    }
    if (impactWeights.weather === 50) {
      weatherMultiplier = 0;
    }
    if (impactWeights.injury === 50) {
      injuryMultiplier_home = 0;
      injuryMultiplier_away = 0;
    }

    // const adjustmentStrength = (Math.abs(impactWeights.stats) / 100);
    const homeDiff = pts_for_home - baseHomeProj;
    const awayDiff = pts_for_away - baseAwayProj;
    const direction = impactWeights.stats > 50 ? 1 : -1;
    
    let adjustedHomeProj = baseHomeProj + (homeDiff * statsWeight * direction);
    let adjustedAwayProj = baseAwayProj + (awayDiff * statsWeight * direction);
    
    
    // Apply location/weather impact (assume home team benefits more)
    const locationImpact = locationMultiplier;
    const adjustedHomeProj2 = adjustedHomeProj + locationImpact;
    const adjustedAwayProj2 = adjustedAwayProj - locationImpact;

    // Apply location/weather impact (assume home team benefits more)
    const weatherImpact = weatherMultiplier;
    const adjustedHomeProj3 = adjustedHomeProj2 + weatherImpact;
    const adjustedAwayProj3 = adjustedAwayProj2 + weatherImpact;
    
    const injuryImpactHome = injuryMultiplier_home;
    let home_proj = adjustedHomeProj3 + injuryImpactHome;
    home_proj = Math.max(0, home_proj);
    const injuryImpactAway = injuryMultiplier_away;
    let away_proj = adjustedAwayProj3 + injuryImpactAway;
    away_proj = Math.max(0, away_proj);
    
    return { home_proj: home_proj.toFixed(1), away_proj: away_proj.toFixed(1) };
  };

  const getAdjustedValues = (item) => {
    // Get adjusted projections from the slider impacts
    const { home_proj: adjustedHomeProjStr, away_proj: adjustedAwayProjStr } = getAdjustedProjections(item);
    const adj_proj_x = parseFloat(adjustedHomeProjStr) || 0;  // adjusted home projection
    const adj_proj_y = parseFloat(adjustedAwayProjStr) || 0;  // adjusted away projection
    let ouvalueadj = 0;
    const sport = (item.Sport || "").toUpperCase();
    // Get the market odds
    const ML_Home = parseFloat(item.ML_Home) || 0;
    const ML_Away = parseFloat(item.ML_Away) || 0;
    let ouValue = parseFloat(item["O/U"]) || 0;
    if (sport === "SOCCER") {
      ouValue = 3;
      ouvalueadj = 0.5;
    }

    
    // Conviction limit - adjust based on your desired confidence level
    let convictionlimit = impactWeights.convictionLimit;
    convictionlimit = Math.max(25, convictionlimit); // minimum limit
    convictionlimit = convictionlimit * 0.1;
    let convictionlimittotals = convictionlimit
    if ((sport === "MLB") || (sport === "NHL")) {
      // convictionlimittotals = convictionlimittotals * 6;
      // convictionlimit = convictionlimit * 3;
    } else if (sport === "SOCCER") {
      convictionlimittotals = convictionlimittotals * 0.8;
     } else if (sport === "CBB") {
      convictionlimittotals = convictionlimittotals * 7.5;
    } else if (sport === "NBA"){
      convictionlimittotals = convictionlimittotals * 8;
      convictionlimit = convictionlimit * 1.2;
    }else {
      convictionlimittotals = convictionlimittotals * 4;
    }


    let implied_sp = adj_proj_x > adj_proj_y 
    ? (adj_proj_x - adj_proj_y) 
    : (adj_proj_y - adj_proj_x);

    if (sport === "NFL" || sport === "CFB") {
      implied_sp /= 7;
    } else if (sport === "NBA" || sport === "CBB") {
      implied_sp /= 7;
    } else if (sport === "MLB" || sport === "NHL") {
      implied_sp /= 7;
    }

    let Proj_ML_Home, Proj_ML_Away, Proj_ML_Draw;


    if (sport === "SOCCER") {
      // Soccer: use probability-based formula
      // Convert projections to probabilities (assume they sum to 100)
      const temptotal = adj_proj_x + adj_proj_y;
      const totalProj = temptotal * 1.25; // assume 33.33% draw
      const home_prob = adj_proj_x / totalProj;
      const away_prob = adj_proj_y / totalProj;
      const draw_prob = (temptotal * 0.25) / totalProj;
      
      // Apply American odds formula
      Proj_ML_Home = home_prob < 0.5 
        ? Math.floor((1 / home_prob - 1) * 100) 
        : Math.floor(-100 / (1 / home_prob - 1));
      
      Proj_ML_Away = away_prob < 0.5 
        ? Math.floor((1 / away_prob - 1) * 100) 
        : Math.floor(-100 / (1 / away_prob - 1));
      
      Proj_ML_Draw = draw_prob < 0.5 
        ? Math.floor((1 / draw_prob - 1) * 100) 
        : Math.floor(-100 / (1 / draw_prob - 1));
      
      // Apply 0.75 multiplier to draw odds
      Proj_ML_Draw = Math.floor(Proj_ML_Draw * 0.75);
    } else {
      
      Proj_ML_Home = adj_proj_x < adj_proj_y 
        ? Math.floor((Math.abs(implied_sp * 100) + 100) * 1.10)
        : Math.floor((-1 * (Math.abs(implied_sp * 100) + 100) * 1.15) + ((Math.abs(implied_sp * 100) + 100) * 1.15 * -0.15));
      
      Proj_ML_Away = adj_proj_y < adj_proj_x 
        ? Math.floor((Math.abs(implied_sp * 100) + 100) * 1.10)
        : Math.floor((-1 * (Math.abs(implied_sp * 100) + 100) * 1.15) + ((Math.abs(implied_sp * 100) + 100) * 1.15 * -0.15));
      
      Proj_ML_Draw = 0; // Not used for non-soccer
    }
    
    // Calculate Value_Home using your formula
    let Value_Home = '';
    if (Proj_ML_Home < ML_Home && Proj_ML_Home < 0) {
      if (ML_Home < 0) {
        // Both negative: subtract absolute values
        Value_Home = Math.floor((Math.abs(Proj_ML_Home) - Math.abs(ML_Home)) / convictionlimit);
      } else {
        // Proj negative, ML positive: add absolute values
        Value_Home = Math.floor((Math.abs(ML_Home) + Math.abs(Proj_ML_Home)) / convictionlimit);
      }
    }
    
    // Calculate Value_Away (mirror logic for away team)
    let Value_Away = '';
    if (Proj_ML_Away < ML_Away && Proj_ML_Away < 0) {
      if (ML_Away < 0) {
        // Both negative: subtract absolute values
        Value_Away = Math.floor((Math.abs(Proj_ML_Away) - Math.abs(ML_Away)) / convictionlimit);
      } else {
        // Proj positive, ML positive: add absolute values
        Value_Away = Math.floor((Math.abs(ML_Away) - Math.abs(Proj_ML_Away)) / convictionlimit);
      }
    }
    
    Value_Home = Value_Home === '' || Value_Home < 1 ? '' : Value_Home;
    Value_Away = Value_Away === '' || Value_Away < 1 ? '' : Value_Away;

    if ((Value_Home > 0) && (Value_Away > 0)) {
      Value_Home = 0;
      Value_Away = 0;
    }

    // let hometeam = item.Home;
    // console.log("Home", hometeam, "Value_Home:", Value_Home, "Value_Away:", Value_Away, "Proj_ML_Home:", Proj_ML_Home);

    // Calculate Proj_Total using your formula
    // Proj_Total is sum of adjusted home and away projections
    const projectedTotal = adj_proj_x + adj_proj_y;
    let Proj_Total = '';
    
    if (ouValue > 0) {
      if (projectedTotal < ouValue) {
        let underValue = Math.floor(((ouValue - ouvalueadj) - projectedTotal) / (3 * (convictionlimittotals / 100)));
        if (sport === "SOCCER") {
          underValue = underValue / 2.5
        }
        underValue = underValue === '' || underValue <= 1 ? '' : underValue;
        Proj_Total = underValue > 0 ? `Under (${underValue})` : "";
      } else {
        let overValue = Math.floor((projectedTotal - (ouValue + ouvalueadj)) / (3 * (convictionlimittotals / 100)));
        if (sport === "SOCCER") {
          overValue = overValue / 2.5
        }
        overValue = overValue === '' || overValue <= 1 ? '' : overValue;
        Proj_Total = overValue > 0 ? `Over (${overValue})` : "";
      }
    }

    if ((impactWeights.stats === 50) && (impactWeights.location === 50) && (impactWeights.weather === 50) && (impactWeights.injury === 50)) {
      if (impactWeights.convictionLimit != 100) {
        let tempValue_Home = '';
        let tempValue_Away = '';
        let temptotalnext = '';
        tempValue_Home = item.Value_Home / convictionlimit *10 || '0';
        tempValue_Away = item.Value_Away / convictionlimit *10 || '0';
        tempValue_Home = tempValue_Home === '' || tempValue_Home < 1 ? '' : tempValue_Home;
        tempValue_Away = tempValue_Away === '' || tempValue_Away < 1 ? '' : tempValue_Away;
        let temptexttotal = item.Proj_Total || '';
        let tempvalueTotal = item.Value_Total || '';

        let projTotalValue = tempvalueTotal / (3 * (convictionlimittotals / 100));
        projTotalValue = Math.floor(projTotalValue);
        projTotalValue = projTotalValue === '' || Math.abs(projTotalValue) <= 1 ? '' : projTotalValue;

        temptotalnext = Math.abs(projTotalValue) > 0 ? `${temptexttotal} (${projTotalValue})` : "";

        return {
          Value_Home: tempValue_Home || '0',
          Value_Away: tempValue_Away || '0',
          Proj_ML_Home: item.Proj_ML_Home || '0',
          Proj_ML_Away: item.Proj_ML_Away || '0',
          Proj_ML_Draw: item.Proj_ML_Draw || '0',
          Proj_Total: temptotalnext || ''
        };
      }
        return {
          Value_Home: item.Value_Home || '0',
          Value_Away: item.Value_Away || '0',
          Proj_ML_Home: item.Proj_ML_Home || '0',
          Proj_ML_Away: item.Proj_ML_Away || '0',
          Proj_ML_Draw: item.Proj_ML_Draw || '0',
          Proj_Total: item.Proj_Total || ''
        };
    }
    
    return { 
      Value_Home: Value_Home === '' ? '0' : Value_Home.toString(),
      Value_Away: Value_Away === '' ? '0' : Value_Away.toString(),
      Proj_ML_Home: Proj_ML_Home.toString(),
      Proj_ML_Away: Proj_ML_Away.toString(),
      Proj_ML_Draw: Proj_ML_Draw.toString(),
      Proj_Total: Proj_Total
    };
  };

  function pickTeam(gameItem) {
    const toNum = (v) => {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : null;
    };

    let teamToBet, teamToFade;

    const sport = (gameItem.Sport || "").toUpperCase();

    const { Value_Home: adjustedValueHome, Value_Away: adjustedValueAway } = getAdjustedValues(gameItem);
    const valueHome = toNum(adjustedValueHome);
    const valueAway = toNum(adjustedValueAway);

    const { home_proj: adjustedHomeProj, away_proj: adjustedAwayProj } = getAdjustedProjections(gameItem);
    const homeProj = toNum(adjustedHomeProj);
    const awayProj = toNum(adjustedAwayProj);

    const spread = toNum(gameItem.Spread_home);
    const hasProj = homeProj !== null && awayProj !== null;
    const EPS = 1e-9;

    // 1) Value signals first (your original behavior)
    if (valueHome !== null && valueHome > 0) {
      return { teamToBet: gameItem.Home, teamToFade: gameItem.Away };
    }
    if (valueAway !== null && valueAway > 0) {
      return { teamToBet: gameItem.Away, teamToFade: gameItem.Home };
    }

    // 2) Spread-aware logic for NFL/CFB/NBA/CBB using edge = (Home_Proj - Away_Proj) + Spread_home
    if (
      ["NFL", "CFB", "NBA", "CBB"].includes(sport) &&
      spread !== null &&
      hasProj
    ) {
      const margin = homeProj - awayProj;     // projected home margin
      const edge = margin + spread;           // projection vs market (home-line)

      if (edge > EPS) {
        teamToBet = gameItem.Home;
        teamToFade = gameItem.Away;
      } else if (edge < -EPS) {
        teamToBet = gameItem.Away;
        teamToFade = gameItem.Home;
      } else {
        // push/tie: lean underdog; if pk, use higher projection
        if (spread < 0) {
          teamToBet = gameItem.Away; // home favored → away is dog
          teamToFade = gameItem.Home;
        } else if (spread > 0) {
          teamToBet = gameItem.Home; // home is dog
          teamToFade = gameItem.Away;
        } else {
          // true pick’em
          if (homeProj >= awayProj) {
            teamToBet = gameItem.Home;
            teamToFade = gameItem.Away;
          } else {
            teamToBet = gameItem.Away;
            teamToFade = gameItem.Home;
          }
        }
      }
      return { teamToBet, teamToFade };
    }

    // 3) Sports without spread or missing spread → use projections
    if (hasProj) {
      if (homeProj >= awayProj) {
        teamToBet = gameItem.Home;
        teamToFade = gameItem.Away;
      } else {
        teamToBet = gameItem.Away;
        teamToFade = gameItem.Home;
      }
      return { teamToBet, teamToFade };
    }

    // 4) Last-resort fallback
    return { teamToBet: gameItem.Home, teamToFade: gameItem.Away };
  }

    function stripCitations(text) {
      const noMdCitations = text.replace(/\s*\(\s*\[[^\]]+\]\((?:https?:\/\/|\/)[^)]+\)\s*\)/gi, "");
      const noBareUrlParens = noMdCitations.replace(/\s*\(\s*(?:https?:\/\/|www\.)[^)]+\)\s*\)/gi, "");
      return noBareUrlParens.replace(/[ \t]+([,;:.!?])/g, "$1").replace(/\s{2,}/g, " ").trim();
    }

  async function fetchAnalysisPrompt(gameItem) {
    setAnalysisLoading(true);
    setAnalysisOutput("");

    // Determine which team to analyze (moneyline bet)
    const { teamToBet, teamToFade } = pickTeam(gameItem);

    let location = (gameItem.location && gameItem.location !== "Game not found in upcoming events") ? gameItem.location : "Home Team Stadium";

    // Qualifiers for context
    const qualifiers = [
      gameItem.Sport ? `Sport: ${gameItem.Sport}` : "",
      gameItem.Time ? `Date: ${gameItem.Time}` : "",
      gameItem["Home Pitcher (WL ERA)"] ? `${gameItem.Home} Pitcher: ${gameItem["Home Pitcher (WL ERA)"]}` : "",
      gameItem["Away Pitcher (WL ERA)"] ? `${gameItem.Away} Pitcher: ${gameItem["Away Pitcher (WL ERA)"]}` : "",
      gameItem.location ? `Location: ${location}` : "",
      gameItem.venue ? `Venue: ${gameItem.venue}` : "",
      gameItem.Spread_home ? `Spread for ${gameItem.Home}: ${gameItem.Spread_home}` : "",
      gameItem["O/U"] ? `O/U: ${gameItem["O/U"]}` : "",
    ].filter(Boolean).join(", ");


    // Build the main moneyline prompt
    let mainPrompt = `Give me a response in 4 sentences or fewer and don't include source citations in the output. Using the latest game summaries, team trends, injury news, and incorporating data about odds movements, can you give me reasons to bet on ${teamToBet} to win or versus the spread when they play against ${teamToFade} today (${qualifiers}) and reasons to not bet them with a recommendation to BET or STAY AWAY, then if the determination is BET, give a confidence on a scale of 1-5 units based on the factors you uncover. Make sure the confidence considers the current odds when recommending a BET or STAY AWAY grade. Also, if the recommendation is to play on the spread then mention that as well.`;

    // Add a separate totals prompt if needed
    let totalsPrompt = "";
    if (gameItem.Proj_Total && (gameItem.Proj_Total.includes("Over") || gameItem.Proj_Total.includes("Under"))) {
      totalsPrompt = `\n\nAdditionally, please provide guidance on the projected total for this game. Specifically, analyze whether betting the ${gameItem.Proj_Total} (${gameItem["O/U"]}) is advisable, including reasons to bet or avoid, and a recommendation to BET or STAY AWAY. If recommending a bet, include a confidence interval (1-5 units) based on the factors you uncover.`;
    }

    // Combine prompts
    const prompt = mainPrompt + totalsPrompt;

    try {
      const response = await fetch("https://api.openai.com/v1/responses", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer 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`
        },
        body: JSON.stringify({
          model: "gpt-5-nano",
          input: prompt,
          tools: [{ type: "web_search" }], // try "web_search_preview" if this errors
          // verbosity: "low"  
        })
      });
      // if (!response.ok) throw new Error(await response.text());

      const data = await response.json();
      console.log("OpenAI response data:", data);
      let analysisText = 
          (data.output_text && data.output_text.trim()) ||
          (Array.isArray(data.output)
          ? data.output.map(b =>
              Array.isArray(b?.content)
                ? b.content.map(c => c?.text || "").join("")
                : ""
            ).join("\n")
          : "") ||
          (data.choices?.[0]?.message?.content || "");

      analysisText = stripCitations(analysisText);
      setAnalysisOutput(analysisText);
    
      // Save analysis to MongoDB Atlas Function
      const user = app.currentUser || await app.logIn(Realm.Credentials.anonymous());
      console.log("gameItem._id:", gameItem._id);
      await user.callFunction("saveAnalysisToGame", gameItem._id, analysisText);
      setModel(prevModel => {
        const sectionKey = `${gameItem.Sport.toLowerCase()}Bets`;
        return {
          ...prevModel,
          [sectionKey]: prevModel[sectionKey].map(bet =>
            bet._id === gameItem._id ? { ...bet, analysis: analysisText } : bet
          ),
          allBets: prevModel.allBets.map(bet =>
            bet._id === gameItem._id ? { ...bet, analysis: analysisText } : bet
          ),
        };
      });
    } catch (err) {
      setAnalysisOutput("Error fetching analysis.");
    }
    setAnalysisLoading(false);
  }

  const handleGameClick = (index, section) => {
    setExpandedGames(prevState => ({
      ...prevState,
      [section]: prevState[section] === index ? null : index
    }));
    setAnalysisOutput(""); // Clear analysis when switching games
  };

  const handleToggleSection = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getRankSuffix = (rank) => {
    if (rank === undefined || rank === null) {
      return "-";
    }
    
    if (rank % 10 === 1 && rank !== 11) {
      return rank + 'st';
    } else if (rank % 10 === 2 && rank !== 12) {
      return rank + 'nd';
    } else if (rank % 10 === 3 && rank !== 13) {
      return rank + 'rd';
    } else {
      return rank + 'th';
    }
  };
  
  const renderWeatherIcon = (item) => {
    const w = (item.weather || item.Weather || "").toString().toLowerCase();
    if (!w || w === "-" || w === "n/a" || w === "--") return null;
    if (w.includes("rain") || w.includes("showers") || w.includes("drizzle")|| w.includes("sleet") || w.includes("hail") || w.includes("snow")) return <CloudDrizzle size={18} className="weather-icon-svg" />;
    if (w.includes("cloud") || w.includes("overcast")) return <Cloud size={18} className="weather-icon-svg" />;
    if (w.includes("wind") || w.includes("windy") || w.includes("mist"))  return <Wind size={18} className="weather-icon-svg" />;
    if (w.includes("thunder") || w.includes("lightning") || w.includes("storm")) return <CloudLightning size={18} className="weather-icon-svg" />;
    return <Sun size={18} className="weather-icon-svg" />;
  };

  const getFormattedTime = (time) => {
    const date = new Date(time); // Parse the date
    const day = date.toLocaleDateString("en-US", { weekday: "short" }); // Get day of the week, e.g., "Wed"
    const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Add leading zero to minutes
    const ampm = date.getHours() < 12 ? "AM" : "PM"; // AM or PM
    return `${hours}:${minutes} ${ampm}`;
};

const getRecord = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "NFL" || sport === "CFB") {
    stat = item["Win-Loss Record_record_" + loc] || "NA";
  } else if (sport === "NHL") {
    stat = `${item["W_" + loc]}-${item["L_" + loc]}-${item["OT_" + loc]} (${getRankSuffix(item["Rk_" + loc])})`;
  } else if (sport === "NBA" || sport === "CBB") {
    stat = item["W-L_" + loc]  || "NA";
  } else if (sport === "Soccer") {
    stat = `${item["won_" + loc]}-${item["lost_" + loc]}-${item["drawn_" + loc]} (${getRankSuffix(item["rank_" + loc])})`;
  } else if (sport === "MLB") {
    stat = `${item["won_" + loc]}-${item["lost_" + loc]}`;
  }else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getGoalieConference = (item, loc) => {
  const sport = item.Sport;
  let stat = "";
  let goalie = "";
  let conf = "";
  let location = "";
  if (loc === 'y'){
    location = 'Away'
  }else if (loc === 'x'){
    location = 'Home'
  }

  if (sport === "CFB") {
    stat = item[location.toLowerCase() + '_conference'] || "NA";
  } else if (sport === "NFL") {
    stat = item[location.toLowerCase() + '_conference'] + " " + item[location.toLowerCase() + '_division'] || "NA";
  } else if (sport === "NHL") {
    goalie = item[location + " Goalie (Blend GAA)"] || "NA";
    conf = item["Conference_" + loc] || "-";
          stat = (
        <>
          {goalie}
          <br />
          {conf}
        </>
      );
  } else if (sport === "NBA" || sport === "CBB") {
    stat = item["Conference_" + loc] || "NA";
  } else if (sport === "Soccer") {
    stat = item["competition"]?.["name"] || "NA";
  } else if (sport === "MLB") {
    // stat = item[location + " Pitcher (WL ERA)"] === "N/A (0-0, 0.0)" ? "NA" : item[location + " Pitcher (WL ERA)"] ?? "NA";
    stat = item[location + " Pitcher (WL ERA)"]
    if (stat && stat.includes("(")) {
      const [beforeParenthesis, afterParenthesis] = stat.split("(");
      stat = (
        <>
          {beforeParenthesis.trim()}
          <br />
          {item[[location.toLowerCase()] + "_pitcher_link"]?.[0] || "NA"}HP ({afterParenthesis.trim()}
        </>
      );
    }
  }else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getResultsText = (sportBets) => {
  const completedGames = sportBets.filter(game => {
    return (game.status === "FT" || game.status === "AOT" || game.status === "AP" || game.status === "AET");
  });
  
  if (completedGames.length === 0) return "";
  
  let totalBets = 0;
  let winners = 0;
  
  completedGames.forEach(game => {
    const validStatuses = ["FT", "AOT", "AP", "AET"];
    const awayScore = parseFloat(game.score_y) || 0;
    const homeScore = parseFloat(game.score_x) || 0;
    const spread = parseFloat(game.Spread_home) || 0;
    
    const isValidGame = validStatuses.includes(game.status) && (homeScore !== 0 || awayScore !== 0);
    
    if (!isValidGame) return;
    
      // Get adjusted values using the new calculation logic
    const { Value_Home: adjustedValueHomeStr, Value_Away: adjustedValueAwayStr, Proj_Total: adjustedProjTotal } = getAdjustedValues(game);
    const adjustedValueHome = parseFloat(adjustedValueHomeStr) || 0;
    const adjustedValueAway = parseFloat(adjustedValueAwayStr) || 0;

    // Check home team winner
    const homeWinner = isValidGame && adjustedValueHome > 0 && (
      spread >= 0
        ? (homeScore + spread) > awayScore
        : (homeScore - Math.abs(spread)) > awayScore
    );
    
    // Check away team winner
    const awayWinner = isValidGame && adjustedValueAway > 0 && (
      spread < 0
        ? spread < (awayScore - homeScore)
        : Math.abs(spread) < (awayScore - homeScore)
    );
    
    // Check over/under winners
    const projTotal = typeof adjustedProjTotal === 'string' ? adjustedProjTotal : '';
    let overUnderMatch = parseFloat(game["O/U"]) || 0;
    if (game.Sport === "Soccer") {
      overUnderMatch = 2.5;
    }
    const overWinner = projTotal.includes("Over") && (awayScore + homeScore) > overUnderMatch;
    const underWinner = projTotal.includes("Under") && (awayScore + homeScore) < overUnderMatch;
    
    // Count each bet individually
    if (adjustedValueHome > 0) {
      totalBets++;
      if (homeWinner) winners++;
    }
    if (adjustedValueAway > 0) {
      totalBets++;
      if (awayWinner) winners++;
    }
    if (projTotal.includes("Over")) {
      totalBets++;
      if (overWinner) winners++;
    }
    if (projTotal.includes("Under")) {
      totalBets++;
      if (underWinner) winners++;
    }
  });
  
  return totalBets > 0 ? `${winners}/${totalBets}` : "";
};


  // helper: pick the latest year *_pts key from the item
  const getLatestPtsKey = (item, obj) => {
    if (!item || typeof item !== "object") return null;
    const keys = Object.keys(item);
    const years = keys
      .map(k => {
        const m = k.match(new RegExp(`^(\\d{4})_${obj}(_[xy])?$`));
        return m ? parseInt(m[1], 10) : null;
      })
      .filter(Boolean);
    if (years.length === 0) return null;
    const maxYear = Math.max(...years);
    // console.log("getLatestPtsKey:", maxYear, obj);
    return `${maxYear}_${obj}`;
  };

const getPts = (item, type, loc) => {
  const sport = item.Sport;
  let stat = "";
  let percentage = 0

  // determine which year_pts object to use (fallback to module 'year' constant)
  const ptsKey = getLatestPtsKey(item, "pts") || `${year}_pts`;
  const ptsObj = item[ptsKey] || {};

  if (sport === "NFL" || sport === "CFB" || sport === "NBA" || sport === "CBB" || sport === "NHL") {
    const value = parseFloat(ptsObj[type + "_" + loc]);
    stat = `${(isNaN(value) ? "NA" : value.toFixed(1))} (${getRankSuffix(item["Rank_pts"]?.[type + "_" + loc]) || "NA"})`;
    percentage = isNaN(value) ? 0 : Math.min((value / 100) * 100, 100);
  // } else if (sport === "NHL") {
  //   stat = ptsObj[type + "_" + loc] || "NA";
  } else if (sport === "Soccer") {
    const value = parseFloat(ptsObj[type + "_" + loc]);
    stat = `${(isNaN(value) ? "NA" : value.toFixed(1))}`;
  } else if (sport === "MLB") {
    const value = parseFloat(ptsObj[type + "_" + loc]);
    stat = `${(isNaN(value) ? "NA" : value.toFixed(1))} (${getRankSuffix(item["Rank_pts"]?.[type + "_" + loc]) || "NA"})`;
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getPassShoot = (item, type, loc) => {
  const sport = item.Sport;
  let stat = "";
  const ptsKey = getLatestPtsKey(item, "shooting") || `${year}_shooting`;
  const ptsObj = item[ptsKey] || {};
  const ptsKey2 = getLatestPtsKey(item, "pass") || `${year}_pass`;
  const ptsObj2 = item[ptsKey2] || {};

  if (sport === "NFL" || sport === "CFB") {
    stat = `${(isNaN(parseFloat(ptsObj2[type + "_" + loc])) ? "NA" : parseFloat(ptsObj2[type + "_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_pass"]?.[type + "_" + loc]) || "NA"})`;
  } else if (sport === "NHL") {
    stat = `${isNaN(item["SF_" + loc] / item["GP_" + loc]) ? "NA" : parseFloat(item["SF_" + loc] / item["GP_" + loc]).toFixed(1)} (${item["SH%-A_" + loc] || "NA"})`;
  } else if (sport === "NBA" || sport === "CBB") {
    stat = `${(isNaN(parseFloat(ptsObj[type + "_" + loc])) ? "" : (parseFloat(ptsObj[type + "_" + loc])).toFixed(1))}% (${getRankSuffix(item["Rank_shooting"]?.[type + "_" + loc]) || "NA"})`;
  } else if (sport === "Soccer") {
    stat = "";
  } else if (sport === "MLB") {
    stat = "";
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getRushEffPP = (item, type, loc) => {
  const sport = item.Sport;
  let stat = "";
  let location = "";
  let olocation = "";
  if (loc === 'y'){
    location = 'away'
    olocation = 'home'
  }else if (loc === 'x'){
    location = 'home'
    olocation = 'away'
  }
  const ptsKey = getLatestPtsKey(item, "ru") || `${year}_ru`;
  const ptsObj = item[ptsKey] || {};
  const ptsKey2 = getLatestPtsKey(item, "defeff") || `${year}_defeff`;
  const ptsObj2 = item[ptsKey2] || {};

  if (sport === "NFL" || sport === "CFB") {
    stat = `${(isNaN(parseFloat(ptsObj[type + "_" + loc])) ? "NA" : parseFloat(ptsObj[type + "_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_ru"]?.[type + "_" + loc]) || "NA"})`;
  } else if (sport === "NHL") {
    // stat = item["ADJ PP%_" + loc] || "NA";
    stat = `${(isNaN(parseFloat(item["ADJ PP%_" + loc])) ? "NA" : parseFloat(item["ADJ PP%_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_PP_" + loc]) || "NA"})`;
  } else if (sport === "NBA" || sport === "CBB") {
    stat = `${(isNaN(parseFloat(ptsObj2[type + "_" + loc])) ? "" : parseFloat(ptsObj2[type + "_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_defeff"]?.[type + "_" + loc]) || "NA"})`;
  } else if (sport === "Soccer") {
    stat = "";
  } else if (sport === "MLB") {
    if (item[[olocation] + "_pitcher_link"] && item[[olocation] + "_pitcher_link"] === "Right") { 
      stat = item["vsright_Avg_" + [loc]] + " (RHP)";
    } else if (item[[olocation] + "_pitcher_link"] && item[[olocation] + "_pitcher_link"] === "Left") { 
      stat = item["vsleft_Avg_" + [loc]] + " (LHP)"
    }

  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getPenPacePK = (item, type, loc) => {
  const sport = item.Sport;
  let stat = "";
  const ptsKey = getLatestPtsKey(item, "pen") || `${year}_pen`;
  const ptsObj = item[ptsKey] || {};
  const ptsKey2 = getLatestPtsKey(item, "pace") || `${year}_pace`;
  const ptsObj2 = item[ptsKey2] || {};

  if (sport === "NFL" || sport === "CFB") {
    stat = `${(isNaN(parseFloat(ptsObj["yrds_" + loc])) ? "NA" : parseFloat(ptsObj["yrds_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_pen"]?.["yrds_" + loc]) || "NA"})`;
  } else if (sport === "NHL") {
    stat = `${(isNaN(parseFloat(item["ADJ PK%_" + loc])) ? "NA" : parseFloat(item["ADJ PK%_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_PK_" + loc]) || "NA"})`;
  } else if (sport === "NBA" || sport === "CBB") {
    stat = `${(isNaN(parseFloat(ptsObj2[type + "_" + loc])) ? "" : parseFloat(ptsObj2[type + "_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_pace"]?.[type + "_" + loc]) || "NA"})`;
  } else if (sport === "Soccer") {
    stat = "";
  } else if (sport === "MLB") {
    stat = parseFloat(item["pitch_mult_" + loc]).toFixed(1) || "NA";
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getGiveMargFO = (item, type, loc) => {
  const sport = item.Sport;
  let stat = "";
  const ptsKey = getLatestPtsKey(item, "gvwys") || `${year}_gvwys`;
  const ptsKey2 = getLatestPtsKey(item, "steals") || `${year}_steals`;
  const ptsObj2 = item[ptsKey2] || {};

  if (sport === "NFL" || sport === "CFB") {
    const gvValue = parseFloat(item[`${ptsKey}_${loc}`]);
    stat = `${(isNaN(gvValue) ? "NA" : gvValue.toFixed(1))} (${getRankSuffix(item["Rank_gvwys_" + loc]) || "NA"})`;
  } else if (sport === "NHL") {
    stat = `${(isNaN(parseFloat(item["FO%_" + loc])) ? "NA" : parseFloat(item["FO%_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_FO_" + loc]) || "NA"})`;
  } else if (sport === "NBA" || sport === "CBB") {
    stat = `${(isNaN(parseFloat(ptsObj2[type + "_" + loc])) ? "NA" : parseFloat(ptsObj2[type + "_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_steals"]?.[type + "_" + loc]) || "NA"})`;
  } else if (sport === "Soccer") {
    stat = "";
  } else if (sport === "MLB") {
    stat = item[year + "_errors_" + loc] || "-";
    stat = `${(isNaN(parseFloat(item[year + "_errors_" + loc])) ? "NA" : parseFloat(item[year + "_errors_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_errors_" + loc]) || "NA"})`;
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getTake = (item, type, loc) => {
  const sport = item.Sport;
  let stat = "";
  const ptsKey = getLatestPtsKey(item, "tkwys") || `${year}_tkwys`;
  const ptsKey2 = getLatestPtsKey(item, "margin") || `${year}_margin`;
  const ptsObj2 = item[ptsKey2] || {};

  if (sport === "NFL" || sport === "CFB") {
   const gvValue = parseFloat(item[`${ptsKey}_${loc}`]);
    stat = `${(isNaN(gvValue) ? "NA" : gvValue.toFixed(1))} (${getRankSuffix(item["Rank_tkwys_" + loc]) || "NA"})`;
  } else if (sport === "NHL") {
    stat = `${isNaN(item["HITS_" + loc] / item["GP_" + loc]) ? "NA" : parseFloat(item["HITS_" + loc] / item["GP_" + loc]).toFixed(1)} (${isNaN(item["HITS-D/GP_" + loc]) ? "NA" : parseFloat(item["HITS-D/GP_" + loc]).toFixed(1)})`;
  } else if (sport === "NBA" || sport === "CBB") {
    stat = `${(isNaN(parseFloat(ptsObj2[type + "_" + loc])) ? "NA" : parseFloat(ptsObj2[type + "_" + loc]).toFixed(1))} (${getRankSuffix(item["Rank_steals"]?.[type + "_" + loc]) || "NA"})`;
  }  else if (sport === "Soccer") {
    stat = "";
  } else if (sport === "MLB") {
    stat = "";
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getInj = (item, loc) => {
  const sport = item.Sport;
  let stat = "";
  if (sport === "NFL" || sport === "CFB") {
    stat = `${isNaN(item["QB_Injury_DYAR"]?.[loc]) || isNaN(item["RB_Injury_DYAR"]?.[loc]) || isNaN(item["WR_Injury_DYAR"]?.[loc]) ? '-' : -parseInt((item["QB_Injury_DYAR"]?.[loc] + item["RB_Injury_DYAR"]?.[loc] + item["WR_Injury_DYAR"]?.[loc]))}`;
  } else if (sport === "NHL" || sport === "NBA" || sport === "CBB") {
    stat = `${isNaN(item["QB_Injury_DYAR"]?.[loc]) || parseFloat(item["QB_Injury_DYAR"]?.[loc]) === 0 ? '-' : (-parseFloat((item["QB_Injury_DYAR"]?.[loc])).toFixed(1))}`;
  } else if (sport === "MLB") {
    stat = `${isNaN(item["Injury_RAR"]?.[loc]) || parseFloat(item["Injury_RAR"]?.[loc]) === 0 ? '-' : (-parseFloat((item["Injury_RAR"]?.[loc])).toFixed(1))}`;
  }else if (sport === "Soccer") {
    stat = `${isNaN(item["injury_impact_" + loc]) || parseFloat(item["injury_impact_" + loc]) === 0 ? '-' : (-parseFloat((item["injury_impact_" + loc])).toFixed(1))}`;
  }else {
    stat = "Sport not recognized";
  }
  return stat;
};

const fmtPct = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
};


const getHandleValue = (item, category, side) => {
  const n = Number(item?.[`handle_${category}`]?.[side]);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
};

const getHandleBar = (
  item,
  category,
  leftSide,
  rightSide,
  leftLabel,
  rightLabel
) => {
  const left = getHandleValue(item, category, leftSide) || 50;
  const right = getHandleValue(item, category, rightSide) || 50;

  if (left === null || right === null) return "NA";

  const isEven = left === 50 && right === 50;

  return (
    <div className="handle-bar-wrap">
      <div
        className={`handle-bar-left ${isEven ? "handle-bar-even" : ""}`}
        style={{ width: `${left}%` }}
      >
        {left}% {leftLabel}
      </div>

      <div
        className={`handle-bar-right ${isEven ? "handle-bar-even" : ""}`}
        style={{ width: `${right}%` }}
      >
        {rightLabel} {right}%
      </div>
    </div>
  );
};

const getForm = (item, loc) => {
  const sport = item.Sport;
  let stat = "";
  let fullloc = "";
  if (loc === 'y') {
    fullloc = 'away';
  } else if (loc === 'x') {
    fullloc = 'home';
  } else if (loc === 'h2h') {
    fullloc = 'h2h';
  }
  
  if (sport === "Soccer") {
    let form = "";
    const formArray = item["form" + "_" + loc];
    if (!formArray || !Array.isArray(formArray) || formArray.length === 0) {
      stat = "-";
    } else {
      form = formArray.join(" "); // Convert the array to a string separated by spaces
    }
    let ouAverage = (item?.[fullloc + "_avg_last6"] ?? "");
    let ouWL = (item?.[fullloc + "_wl_last6"] ?? "");

    if (fullloc === "h2h" && ouAverage !== "" && ouWL !== "") {
      stat = (
        <>
          {ouWL} ({ouAverage})
        </>
      );
    } else if (ouAverage !== "" && ouWL !== "") {
      stat = (
        <>
          {form}
          <br />
          <br />
          {ouWL} ({ouAverage})
        </>
      );
    } else {
      stat = form;
    }
  }
  
  return stat;
};


const getInjDetail = (item, loc) => {
  const sport = item.Sport;
  let stat = "";
    const injuryDetail = item["Injury_detail"]?.[loc];
    
    if (injuryDetail && injuryDetail !== "None" && injuryDetail !== "") {
      // Split by comma and create list items
      const injuryList = injuryDetail.split(',').map((inj, index) => (
        <div key={index} style={{ marginBottom: '1px' }}>
          {inj.trim()}
        </div>
      ));
      stat = <div>{injuryList}</div>;
    } else {
      stat = "None";
  }
  return stat;
};

const getRankString = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "CBB" || sport === "CFB") {
    stat = `${(isNaN(parseFloat(item[`${year}_gvwys_` + loc])) ? "NA" : parseFloat(item[`${year}_gvwys_` + loc]).toFixed(1))} (${getRankSuffix(item["Rank_gvwys_" + loc]) || "NA"})`;
  } else if (sport === "NHL" || sport === "NFL" || sport === "NBA" || sport === "Soccer") {
    stat = "-";
  } else if (sport === "MLB") {
    stat = `-`;
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getBye = (item, type, loc) => {
  const sport = item.Sport;
  let stat = "";
  if (sport === "NFL" || sport === "CFB") {
    stat = item["Bye_" + loc] || "-";
    if (item["Bye_" + loc] + 1 === item.Week)
      stat = stat + " (" + item["ATS Record_bye_ats_" + loc] + " ATS) (" + item["Over Record_bye_ou_" + loc] + " OU)"
  } else if (sport === "NHL") {
    stat = "";
  } else if (sport === "NBA") {
    stat = item[`${year}_lead`]?.[type + "_" + loc];
  } else if (sport === "CBB") {
    stat = "";
  } else if (sport === "Soccer") {
    stat = "";
  } else if (sport === "MLB") {
    stat = "";
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getConfRec = (item, loc) => {
  const sport = item.Sport;
  let stat = "";
  if (sport === "NBA" || sport === "CBB") {
    if (item.Conference_x == item.Conference_y) {
      stat = item["ATS Record_conf_record_" + loc] + " (" + item["ATS +/-_conf_record_" + loc] + ") ";
    } else {
      stat = item["ATS Record_nonconf_record_" + loc] + " (" + item["ATS +/-_nonconf_record_" + loc] + ") ";
    }
    if (stat === "undefined (undefined) ") {
      stat = "-";
    }
  } else if (sport === "CFB") {
      if (item.home_conference == item.away_conference) {
      stat = item["ATS Record_conf_rec_" + loc] + " (" + item["ATS +/-_conf_rec_" + loc] + ")";
    } else {
      stat = item["ATS Record_nonconf_rec_" + loc] + " (" + item["ATS +/-_nonconf_rec_" + loc] + ")";
    }
    if (stat === "undefined (undefined)") {
      stat = "-";
    }
  } else if (sport === "NFL") {
        if (item.home_conference + item.home_division == item.away_conference + item.away_division) {
      stat = item["ATS Record_conf_rec_" + loc] + " (" + item["ATS +/-_conf_rec_" + loc] + ")";
    } else {
      stat = item["ATS Record_nonconf_rec_" + loc] + " (" + item["ATS +/-_nonconf_rec_" + loc] + ")";
    }
    if (stat === "undefined (undefined)") {
      stat = "-";
    }
  } else if ((sport === "Soccer") || (sport === "MLB") || (sport === "NHL")) {
    stat = "-";
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getATS = (item, loc) => {
  const sport = item.Sport;
  let stat = "";
  if (sport === "NFL" || sport === "CFB" || sport === "NBA" || sport === "CBB") {
    stat = item["ATS Record_ats_" + loc] + " (" + item["ATS +/-_ats_" + loc] + ") ";
  } else if (sport === "Soccer") {
    stat = "-";
  } else if (sport === "MLB") {
    if  (loc === "x")
      stat = item["Win-Loss Record_wl_home_" + loc] + " (" + item["Run Line +/-_wl_home_" + loc] + ")" || "-";
    else stat = item["Win-Loss Record_wl_away_" + loc] + " (" + item["Run Line +/-_wl_away_" + loc] + ")" || "-";
  } else if (sport === "NHL") {
    if  (loc === "x")
      stat = item["Record_wl_home_" + loc] || "-";
    else stat = item["Record_wl_away_" + loc] || "-";
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getRecordAs = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "NFL" || sport === "CFB") {

    if (item["ML_Home"] < 0)
      if  (loc === "x")
        stat = item["ATS Record_home_fav_" + loc] + " (" + item["ATS +/-_home_fav_" + loc] + ") " + " (home fav)" || "-";
      else stat = item["ATS Record_away_dog_" + loc] + " (" + item["ATS +/-_away_dog_" + loc] + ") " + " (away dog)" || "-";
    else
      if  (loc === "x")
        stat = item["ATS Record_home_dog_" + loc] + " (" + item["ATS +/-_home_dog_" + loc] + ") " + " (home dog)" || "-";
      else stat = item["ATS Record_away_fav_" + loc] + " (" + item["ATS +/-_away_fav_" + loc] + ") " + " (away fav)"  || "-";
  } else if (sport === "NHL") {
      stat = item["Record_ats_" + loc] || "-";
  } else if (sport === "NBA" || sport === "CBB") {
    if (item["ML_Home"] < 0)
      if  (loc === "x")
        stat = item["ATS Record_home_fav_" + loc] + " (" + item["ATS +/-_home_fav_" + loc] + ") " + " (home fav)" || "-";
      else stat = item["ATS Record_away_dog_" + loc] + " (" + item["ATS +/-_away_dog_" + loc] + ") " + " (away dog)" || "-";
    else
      if  (loc === "x")
        stat = item["ATS Record_home_dog_" + loc] + " (" + item["ATS +/-_home_dog_" + loc] + ") " + " (home dog)" || "-";
      else stat = item["ATS Record_away_fav_" + loc] + " (" + item["ATS +/-_away_fav_" + loc] + ") " + " (away fav)"  || "-";
  } else if (sport === "Soccer") {
    stat = "";
  } else if (sport === "MLB") {
    if (item["ML_Home"] < 0)
      if  (loc === "x")
        stat = item["Win-Loss Record_home_fav_" + loc] + " (" + item["Run Line +/-_home_fav_" + loc] + ") " + " (home fav)" || "-";
      else stat = item["Win-Loss Record_away_dog_" + loc] + " (" + item["Run Line +/-_away_dog_" + loc] + ") " + " (away dog)" || "-";
    else
      if  (loc === "x")
        stat = item["Win-Loss Record_home_dog_" + loc] + " (" + item["Run Line +/-_home_dog_" + loc] + ") " + " (home dog)" || "-";
      else stat = item["Win-Loss Record_away_fav_" + loc] + " (" + item["Run Line +/-_away_fav_" + loc] + ") " + " (away fav)"  || "-";
  }else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getRecordAt = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "NFL" || sport === "CFB" || sport === "NBA" || sport === "CBB" || sport === "MLB") {
    if (loc === "x") {
      stat = item["ATS Record_ats_home_" + loc] + " (" + item["ATS +/-_ats_home_" + loc] + ")" || "-";
    } else {
      stat = item["ATS Record_ats_away_" + loc] + " (" + item["ATS +/-_ats_away_" + loc] + ")" || "-";
    }
  } else if (sport === "NHL") {
      stat = "";
  } else if (sport === "Soccer") {
    stat = "-";
  } else {
    stat = "Sport not recognized";
  }
  if (stat === "undefined (undefined)") {
    stat = "-";
  }
  return stat;
};

const getOURecord = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "NFL" || sport === "CFB" || sport === "NBA" || sport === "CBB" || sport === "MLB") {
    stat = item["Over Record_over_under_" + loc] + " (" + item["Total +/-_over_under_" + loc] + ")" || "-";
  } else if (sport === "NHL") {
      stat = item["Record_ou_" + loc] || "-";
  } else if (sport === "Soccer") {
    stat = "-";
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getOURecordAt = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "MLB") {
    if  (loc === "x")
      stat = item["Over Record_ou_home_" + loc] + " (" + item["Total +/-_ou_home_" + loc] + ")" || "-";
    else{
      stat = item["Over Record_ou_away_" + loc] + " (" + item["Total +/-_ou_away_" + loc] + ")" || "-";     
    }
  } else if (sport === "NHL" || sport === "CBB" || sport === "Soccer" || sport === "NFL" || sport === "CFB" || sport === "NBA" || sport === "Socer") {
    stat = "-";
  } else {
    stat = "Sport not recognized";
  }
  return stat;
};

const getDaysRest = (item, loc) => {
  const sport = item.Sport;
  let stat = "";
  if (sport === "NFL" || sport === "NBA" || sport === "NHL") {
    stat = item["daysRest_" + loc] || "-";
  } else{
    stat = "-";
  }
  return stat;
};

const getRestRec = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "NFL" || sport === "NBA") {
    const daysRestHome = item["daysRest_x"];
    const daysRestAway = item["daysRest_y"];
    
    if (daysRestHome === undefined || daysRestHome === null || daysRestAway === undefined || daysRestAway === null) {
      stat = "-";
    } else {
      const restDifference = loc === "x" ? daysRestHome - daysRestAway : daysRestAway - daysRestHome;
      
      if (restDifference >= 1) {
        stat = item[`Win-Loss Record_rest_adv_${loc}`] + " (" + item[`ATS +/-_rest_adv_${loc}`] + ") (" + item[`daysRest_${loc}`] + ")" || "-";
      } else if (restDifference <= -1) {
        stat = item[`Win-Loss Record_rest_disadv_${loc}`] + " (" + item[`ATS +/-_rest_disadv_${loc}`] + ") (" + item[`daysRest_${loc}`] + ")" || "-";
      } else {
        stat = item[`Win-Loss Record_rest_equal_${loc}`] + " (" + item[`ATS +/-_rest_equal_${loc}`] + ") (" + item[`daysRest_${loc}`] + ")" || "-";
      }
    }
  } else if (sport === "NHL") {
    stat = item[`daysRest_${loc}`] || "-";
  }else{
    stat = "-";
  }
  
  return stat;
};

const getOURestRec = (item, loc) => {
  const sport = item.Sport;
  let stat = "";
  
  if (sport === "NFL" || sport === "NBA") {
    const daysRestHome = item["daysRest_x"];
    const daysRestAway = item["daysRest_y"];
    
    if (daysRestHome === undefined || daysRestHome === null || daysRestAway === undefined || daysRestAway === null) {
      stat = "-";
    } else {
      const restDifference = loc === "x" ? daysRestHome - daysRestAway : daysRestAway - daysRestHome;
      
      if (restDifference >= 1) {
        stat = item[`Over Record_ou_rest_adv_${loc}`] + " (" + item[`Total +/-_ou_rest_adv_${loc}`] + ") (adv)" || "-";
      } else if (restDifference <= -1) {
        stat = item[`Over Record_ou_rest_disadv_${loc}`] + " (" + item[`Total +/-_ou_rest_disadv_${loc}`] + ") (disadv)" || "-";
      } else {
        stat = item[`Over Record_ou_rest_equal_${loc}`] + " (" + item[`Total +/-_ou_rest_equal_${loc}`] + ") (equal)" || "-";
      }
    }
  } else {
    stat = "-";
  }
  
  return stat;
};

const getScore = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "NHL" || sport === "CBB" || sport === "Soccer" || sport === "NFL" || sport === "CFB" || sport === "NBA" || sport === "MLB") {
    const key = `score_${loc}`;
    const score = item[key];

    if (score === undefined || score === null || Number.isNaN(score) || item.status === "NS") {
      // console.error(`Invalid score for key '${key}'`);
      stat = "-";
    } else {
      stat = score;
    }}
  else {
    stat = "-";
  }
    return stat;
};

const getLocation = (item) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "Soccer"  || sport === "NFL" || sport === "CFB") {
    let location = item["location"];
    const homeLocation = item["team"]?.["stadium_x"] || "NA";
    if (location === undefined || location === null || location === "" || location === "Game not found in upcoming events") {
      console.error(`Invalid location data for key '${item.Home}'`);
      location = "-";
      return location;
    } else {
      if (location === homeLocation){
        location = location;
    } 
    else if (sport === "Soccer") 
    {location = location + " (Neutral)"}
    }
    const temp = item["Temp"] && item["Temp"] !== "-" ? `${parseFloat(item["Temp"]).toFixed(0)}°F` : "";
    const weather = item["Weather"];
    const city = item["City"] ? item["City"] : "";

    stat = (
      <>
        {location}
        <br />
        {city}    
        <br />        
        {temp} {weather}      
      </>
    );
  } else if (sport === "MLB") {
    const location = item["venue"];
    const temp = item["temp"] ? `${item["temp"]}°F` : "NA";
    const weather = item["weather"];
    const wind = item["wind"];
    const series = item["series"] && item["series"] === "0-0" ? "Series: " + item["series"] : item["series"];
    const matchup_url = item["matchup_url"];

    stat = (
      <>
        {location}
        <br />
        {temp} {weather}  
        <br />
        {wind}      
        <br />
        {series}
        <br />
        {matchup_url && (
          <a href={matchup_url} target="_blank" rel="noopener noreferrer">
            Matchup Page
          </a>
        )}
      </>
    );

  } else if (sport === "NHL" || sport === "NBA") {
    const location = item["location"];
    const city = item["City"] ? item["City"] : "";
    stat = (
      <>
        {location}
        <br />
        {city}        
      </>
    );
  }else {
    stat = "-";
  }
  return stat;
};

const getH2H = (item, loc) => {
  const sport = item.Sport;
  let stat = "";

  if (sport === "Soccer") {
    const h2h = item["h2h"];
    if (h2h === undefined || h2h === null || h2h === "") {
      console.error(`Invalid h2h data for key '${item.Home}'`);
      stat = "-";
    } else {
      stat = h2h;
    }}
  else {
    stat = "-";
  }
  return stat;
};


const getML = (item, loc) => {
  const home = item.ML_Home;
  const away = item.ML_Away;
  const draw = item.ML_Draw;

  if (home !== draw && away !== draw && home != "100" && home != "0") {
    if (loc === "x") {
      return home
    }else if (loc === "y") {
      return away
    }else if (loc === "draw") {
      return draw
    }
  }else{
    return "-";
  }
};

const getOU = (item) => {
  if (item.Sport === "Soccer") {
    return 2.5;
  } else if (item["O/U"] != '0'){
    return item["O/U"];
  } else{
    return "-";
  }
}

// Around line 1211, update the getRecommendation function:
const getRecommendation = (item) => {
  const sport = item.Sport;
  let side = "";
  let ou = "";
  let stat = "";

  const formatSpread = (s) => {
    const n = parseFloat(s);
    if (Number.isNaN(n)) return s || "";
    const rounded = Math.round(n);
    return (rounded > 0 ? `+${rounded}` : `${rounded}`);
  };

  // Get adjusted values
  const { Value_Home: adjustedValueHome, Value_Away: adjustedValueAway, Proj_Total: adjustedProjTotal } = getAdjustedValues(item);
  const valueHome = parseFloat(adjustedValueHome);
  const valueAway = parseFloat(adjustedValueAway);

  if (sport) {
    if (valueHome > 0) {
      side += "Play " + item.Home;
      if (sport === "MLB" || sport === "NHL" || sport === "Soccer") {
        side += " ML " + formatSpread(getML(item, 'x'));
      }
      else{
        side += " " + formatSpread(item.Spread_home);
      }
    } else if (valueAway > 0) {
      side += "Play " + item.Away;
      if (sport === "MLB" || sport === "NHL" || sport === "Soccer") {
        side += " ML " + formatSpread(getML(item, 'y'));
      }
      else{
        side += " " + formatSpread(-item.Spread_home);
      }
    }
    // Add type check here
    const projTotal = typeof adjustedProjTotal === 'string' ? adjustedProjTotal : '';
    if (projTotal.includes("Over")) {
      ou += "Play Over " + getOU(item);
    }
    else if (projTotal.includes("Under")) {
      ou += "Play Under " + getOU(item);
    }
  } else {
    stat = "N/A";
  }
  if (side && ou) {
    stat = (
        <>
          {side}      
          <br />
          {ou}
        </>
      );
  } else if (side) {
    stat = side;
  } else if (ou) {
    stat = ou;
  }
  return stat;
};

const containsText = (jsx, text) => {
  let found = false;

  React.Children.forEach(jsx, (child) => {
    if (typeof child === "string" && child.includes(text)) {
      found = true;
    } else if (React.isValidElement(child)) {
      found = containsText(child.props.children, text) || found;
    }
  });

  return found;
};

const hasMissingGoalieData = (item) => {
  if (!item.Sport.includes("MLB") && !item.Sport.includes("NHL")) return false;
  
  const goalieX = String(item["Home Goalie (Blend GAA)"] || '').toLowerCase();
  const goalieY = String(item["Away Goalie (Blend GAA)"] || '').toLowerCase();
  const confX = String(item["Conference_x"] || '').toLowerCase();
  const confY = String(item["Conference_y"] || '').toLowerCase();
  const location = String(getLocation(item) || '').toLowerCase();
  
  return (
    goalieX.includes("unknown") ||
    goalieY.includes("unknown") ||
    confX.includes("n/a") ||
    confY.includes("n/a") ||
    location.includes("n/a")
  );
};

const ValueIndicator = ({ value, item, isHome }) => {
  const dotColor = hasMissingGoalieData(item) ? 'var(--accent-error)' : 'var(--accent-gold)';
  const spread = isHome 
    ? (item.Spread_home ? formatSpread(item.Spread_home) : formatSpread(getML(item, 'x')))
    : (item.Spread_home ? formatSpread(-item.Spread_home) : formatSpread(getML(item, 'y')));

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {hasMissingGoalieData(item) ? 
        <span className="orange-dot-left"></span> 
        : <span className="gold-dot-left"></span> 
      }
      <span style={{ fontSize: '0.8em', color: dotColor }}>
        {spread}
      </span>
    </div>
  );
};

// const getModelPts = (item, loc) => {
//   const sport = item.Sport;
//   // let stat = "";
//   let score = 0;


//   if (sport === "CBB") {
//     if (loc === 'x'){
//       const intercept = 79.0955
//       score = intercept
//       - 0.008069 * item.Rank_x
//       + 0.004427 * item.Rank_y
//       + 0.438854 * item.Rating_FPI_x
//       - 0.308953 * item.Rating_FPI_y
//       - 0.343149 * item.home_conf_adj
//       - 0.909541 * item.away_conf_adj
//       - 0.005641 * item.Home_Proj
//       - 0.010733 * item.Away_Proj
//     } else if (loc === 'y'){
//       const intercept = 72.6554
//       score = intercept
//       - 0.016298 * item.Rank_x
//       - 0.027104 * item.Rank_y
//       - 0.282866 * item.Rating_FPI_x
//       + 0.119166 * item.Rating_FPI_y
//       - 0.547837 * item.home_conf_adj
//       + 2.686437 * item.away_conf_adj
//       + 0.025492 * item.Home_Proj
//       + 0.057561 * item.Away_Proj
//   }}
//   else {
//     score = "-";
//   }
//   return score;
// }

const getSimilarSituationGames = async () => {
  const currentStat = situationAnalysisData[`${year}_${baseType}`]?.[suffix] || situationAnalysisData[`${year}_${baseType}_${suffix}`] || parseFloat(situationAnalysisData[baseType + '_' + suffix]);
  const currentDate = new Date(situationAnalysisData.Date);
  if (!currentStat) return [];
  
  try {
    // Fetch all models/games data
    const modelData = await getModel(situationAnalysisData.Sport);
    
    // Filter games where the stat is similar (within 0.5 tolerance)
  return modelData.filter(game => {
    const isbeforeCurrentDate = new Date(game.Date) < currentDate;
    const gameStat = game[`${year}_${baseType}`]?.[suffix] || game[`${year}_${baseType}_${suffix}`] || parseFloat(game[baseType + '_' + suffix]);
    return validStatuses.includes(game.status) && isbeforeCurrentDate && gameStat !== null && gameStat !== undefined && Math.abs(gameStat - currentStat) < Math.max(Math.abs(currentStat) * 0.25, 0.1);
  });
  } catch (error) {
    console.error('Error fetching similar games:', error);
    return [];
  }
};

const getAnalysisKey = (type, location) => {
  const temp = type?.replace("Rush","Ru").replace("Penalty","Pen").replace("Def Eff","defeff").replace("Giveaways", "Gvwys").replace("Takeaways", "Tkwys").replace("Power ", "");
  let baseType = temp?.split(' ')[0].toLowerCase();
  // Extract the second word (For or Against) and abbreviate
  let statType = type?.toLowerCase().includes('for') ? 'for' : type?.toLowerCase().includes('ag') ? 'ag' : 'for';
  if (temp?.toLowerCase().includes('pen')) {
    statType = 'yrds'
  }

  let suffix = location === 'home' ? `${statType}_x` : `${statType}_y`;
  let oppsuffix = location === 'home' ? `${statType}_y` : `${statType}_x`;

  if (temp?.toLowerCase().includes('gvwys') || temp?.toLowerCase().includes('tkwys')) {
    statType = ''
    suffix = location === 'home' ? `${statType}x` : `${statType}y`;
    oppsuffix = location === 'home' ? `${statType}y` : `${statType}x`;
  }
  if (temp?.toLowerCase().includes('errors')) {
    statType = ''
    suffix = location === 'home' ? `${statType}x` : `${statType}y`;
    oppsuffix = location === 'home' ? `${statType}y` : `${statType}x`;
  }
  if (temp?.toLowerCase().includes('rating')) {
    statType = ''
    baseType = 'Rating_FPI'
    suffix = location === 'home' ? `${statType}x` : `${statType}y`;
    oppsuffix = location === 'home' ? `${statType}y` : `${statType}x`;
  }
  if (temp?.toLowerCase().includes('rest')) {
    statType = ''
    baseType = 'daysRest'
    suffix = location === 'home' ? `${statType}x` : `${statType}y`;
    oppsuffix = location === 'home' ? `${statType}y` : `${statType}x`;
  }
  if (temp?.toLowerCase().includes('pp') || temp?.toLowerCase().includes('pk')) {
    statType = ''
    baseType = `ADJ ${temp.toUpperCase()}%`
    suffix = location === 'home' ? `${statType}x` : `${statType}y`;
    oppsuffix = location === 'home' ? `${statType}y` : `${statType}x`;
  }
  if (temp?.toLowerCase().includes('faceoff')) {
    statType = ''
    baseType = `FO%`
    suffix = location === 'home' ? `${statType}x` : `${statType}y`;
    oppsuffix = location === 'home' ? `${statType}y` : `${statType}x`;
  }
  if (temp?.toLowerCase().includes('shots')) {
    statType = ''
    baseType = `SH%-A`
    suffix = location === 'home' ? `${statType}x` : `${statType}y`;
    oppsuffix = location === 'home' ? `${statType}y` : `${statType}x`;
  }
  if (temp?.toLowerCase().includes('hits')) {
    statType = ''
    baseType = `HITS-D/GP`
    suffix = location === 'home' ? `${statType}x` : `${statType}y`;
    oppsuffix = location === 'home' ? `${statType}y` : `${statType}x`;
  }
  
  // console.log('getAnalysisKey:', { baseType, suffix, location, statType });
  
  return { baseType, suffix, oppsuffix };
};

const formatSpread = (spread) => {
  const num = parseFloat(spread);
  if (isNaN(num)) return spread;
  if (Number.isInteger(num)) {
    return num > 0 ? `+${num}` : `${num}`;
  }
  return num > 0 ? `+${num.toFixed(1)}` : `${num.toFixed(1)}`;
};

const getInitials = (teamName) =>
  teamName
    ?.split(" ")
    .map(word => word[0])
    .join("")
    .toUpperCase();

  const renderGridRows = (betData, section) => {
    if (loading) {return <div className="loader"></div>;}

    return betData.map((item, index) => {
      const { Value_Home: adjustedValueHome, Value_Away: adjustedValueAway } = getAdjustedValues(item);
      const itemValueHome = parseFloat(adjustedValueHome);
      const itemValueAway = parseFloat(adjustedValueAway);

      const {Proj_ML_Home, Proj_ML_Away, Proj_ML_Draw, Proj_Total: adjustedProjTotal } = getAdjustedValues(item);

      const statistics = [
        { type: "Pts For", home: getPts(item, "for", "x"), away: getPts(item, "for", "y") },
        { type: "Pts Against", home: getPts(item, "ag", "x"), away: getPts(item, "ag", "y") },

        { 
          type: item.Sport && item.Sport.includes("NHL") 
            ? "Shots (% For)" 
            : item.Sport.includes("NBA") || item.Sport.includes("CBB") 
            ? "Shooting" 
            : item.Sport.includes("NFL") || item.Sport.includes("CFB") 
            ? "Pass Yards" 
            : "",
          home: getPassShoot(item, "for", "x"), 
          away: getPassShoot(item, "for", "y")
        },

        {
          type: item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) 
            ? "Pass Yds Ag" 
            : "",
          home: item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) 
            ? getPassShoot(item, "ag", "x") 
            : "",
          away: item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) 
            ? getPassShoot(item, "ag", "y") 
            : ""
        },
        
        {
          type: item.Sport && item.Sport.includes("NHL")
            ? "PP"
            : item.Sport.includes("NBA") || item.Sport.includes("CBB")
            ? "Def Eff"
            : item.Sport.includes("NFL") || item.Sport.includes("CFB")
            ? "Rush Yds"
            : item.Sport.includes("MLB")
            ? "Avg vs Hand"
            : "",
          home: getRushEffPP(item, "for", "x"),
          away: getRushEffPP(item, "for", "y")
        },
        {
          type: item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) 
            ? "Rush Yds Ag" 
            : "",
          home: item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) 
            ? getRushEffPP(item, "ag", "x") 
            : "",
          away: item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) 
            ? getRushEffPP(item, "ag", "y") 
            : ""
        },

        {
          type: item.Sport && item.Sport.includes("NHL")
            ? "PK"
            : item.Sport.includes("NBA") || item.Sport.includes("CBB")
            ? "Pace"
            : item.Sport.includes("NFL") || item.Sport.includes("CFB")
            ? "Penalty Yds"
            : item.Sport.includes("MLB")
            ? "Mult vs Hand"
            :"",
          home: getPenPacePK(item, "for", "x"),
          away: getPenPacePK(item, "for", "y")
        },

        {
          type: item.Sport && item.Sport.includes("NHL")
            ? "Faceoff"
            : item.Sport.includes("NBA") || item.Sport.includes("CBB")
            ? "Steals"
            : item.Sport.includes("NFL") || item.Sport.includes("CFB")
            ? "Giveaways"
            : item.Sport.includes("MLB")
            ? "Errors"
            : "",
          home: getGiveMargFO(item, "for", "x"),
          away: getGiveMargFO(item, "for", "y")
        },

        {
          type: item.Sport && item.Sport.includes("NHL")
            ? "Hits (Diff)"
            : item.Sport.includes("NBA") || item.Sport.includes("CBB")
            ? "Margin"
            : item.Sport.includes("NFL") || item.Sport.includes("CFB")
            ? "Takeaways"
            : "",
          home: getTake(item, "for", "x"),
          away: getTake(item, "for", "y")
        },


        {
          type: item.Sport.includes("NBA") || item.Sport.includes("CBB")
            ? "Avg Lead"
            : item.Sport.includes("NFL") || item.Sport.includes("CFB")
            ? "Bye Week"
            :"",
          home: getBye(item, "for", "x"),
          away: getBye(item, "for", "y")
        },

        {
          type: item.Sport && (item.Sport.includes("NBA") || item.Sport.includes("NHL")) 
            ? "Rest" 
            : "",
          home: item.Sport && (item.Sport.includes("NBA") || item.Sport.includes("NHL")) 
            ? getDaysRest(item, "x")
            : "",
          away: item.Sport && (item.Sport.includes("NBA") || item.Sport.includes("NHL")) 
            ? getDaysRest(item, "y")
            : ""
        },

        { 
          type: item.Sport.includes("MLB") || item.Sport.includes("NHL")
            ? ""
            : "Power Rating", 
          home: item.Sport.includes("MLB") || item.Sport.includes("NHL")
          ? ""
          : `${item.Rating_FPI_x} ${
                (parseFloat(item.Rating_FPI_x) + getHomeAdv(item.Sport) - parseFloat(item.Rating_FPI_y)) > 0 
                  ? `(${(parseFloat(item.Rating_FPI_x) + getHomeAdv(item.Sport) - parseFloat(item.Rating_FPI_y)).toFixed(1)})` 
                  : ""
              }`,
          away: item.Sport.includes("MLB") || item.Sport.includes("NHL")
          ? ""
          : `${item.Rating_FPI_y} ${
                (parseFloat(item.Rating_FPI_y) - getHomeAdv(item.Sport) - parseFloat(item.Rating_FPI_x)) > 0 
                  ? `(${(parseFloat(item.Rating_FPI_y) - getHomeAdv(item.Sport) - parseFloat(item.Rating_FPI_x)).toFixed(1)})` 
                  : ""
              }`,
        }

      ];
      const isExpanded = expandedGames[section] === index;
      // Calculate the score difference and check against the spread
      const awayScore = parseFloat(getScore(item, 'y')) || 0;
      const homeScore = parseFloat(getScore(item, 'x')) || 0;
      const spread = parseFloat(item.Spread_home) || 0;
      
      // Ensure the game status is valid and scores are non-zero
      const isValidGame = validStatuses.includes(item.status) && (homeScore !== 0 || awayScore !== 0);
      
      // Determine home winner and loser
      const homeWinner = isValidGame && parseFloat(itemValueHome) > 0 && (
        spread >= 0
          ? (homeScore + spread) > awayScore
          : (homeScore - Math.abs(spread)) > awayScore
      );
      
      const homeLoser = isValidGame && parseFloat(itemValueHome) > 0 && (
        spread >= 0
          ? (homeScore + spread) < awayScore
          : (homeScore - Math.abs(spread)) < awayScore
      );
      
      // Determine away winner and loser
      const awayWinner = isValidGame && parseFloat(itemValueAway) > 0 && (
        spread < 0
          ? spread < (awayScore - homeScore)
          : Math.abs(spread) < (awayScore - homeScore)
        );
      
      const awayLoser = isValidGame && parseFloat(itemValueAway) > 0 && (
        spread < 0 
          ? spread > (awayScore - homeScore) 
          : Math.abs(spread) > (awayScore - homeScore)
      );
      
      let overUnderTotal = parseFloat(item["O/U"]);
      if (item.Sport === "Soccer") {
        overUnderTotal = 2.5;
      }
      // Determine over/under winners and losers
      const overWinner = isValidGame && typeof adjustedProjTotal === 'string' && adjustedProjTotal.includes("Over") && (awayScore + homeScore) > overUnderTotal;
      const overLoser = isValidGame && typeof adjustedProjTotal === 'string' && adjustedProjTotal.includes("Over") && (awayScore + homeScore) < overUnderTotal;
      const underWinner = isValidGame && typeof adjustedProjTotal === 'string' && adjustedProjTotal.includes("Under") && (awayScore + homeScore) < overUnderTotal;
      const underLoser = isValidGame && typeof adjustedProjTotal === 'string' && adjustedProjTotal.includes("Under") && (awayScore + homeScore) > overUnderTotal;
      
      // Determine overall winner and loser
      const winner = (
        [homeWinner, awayWinner, overWinner, underWinner].filter(Boolean).length === 1 &&
        ![homeLoser, awayLoser, overLoser, underLoser].some(Boolean)
      );
      
      const loser = (
        [homeLoser, awayLoser, overLoser, underLoser].filter(Boolean).length === 1 &&
        ![homeWinner, awayWinner, overWinner, underWinner].some(Boolean)
      );
      
      // Determine double winners and losers
      const dubwinner = (
        [homeWinner, awayWinner, overWinner, underWinner].filter(Boolean).length > 1
      );
      
      const dubloser = (
        [homeLoser, awayLoser, overLoser, underLoser].filter(Boolean).length > 1
      );

      // console.log("handle test:", item?.["handle"]);
      return (
        <div
            key={index}
            className={`grid-item-container ${
              winner ? 'game-winner' :
              loser ? 'game-loser' :
              dubwinner ? 'game-dub-winner' :
              dubloser ? 'game-dub-loser' :
              ''
            } ${hasActiveBet(item, activeBets) ? 'game-with-bet' : ''}`}
        >

          <div className="match-container" onClick={() => handleGameClick(index, section)}>
            <div className="time">{getFormattedTime(item.Time)}</div>
            <div className="teams">
              <div className="away-team">
                {item.Logo_y ? (<><img src={item.Logo_y} alt="" className="team-logo" />{item.Away}</>) : (item.Away)}
                {item.CFP_Rank_Away && item.CFP_Rank_Away !== "-" && (
                  <span className="cfp-rank-badge">{item.CFP_Rank_Away}</span>
                )}
              </div>
              <div className="home-team">
                {item.Logo_x ? (<><img src={item.Logo_x} alt="" className="team-logo" />{item.Home}</>) : (item.Home)}
                {item.CFP_Rank_Home && item.CFP_Rank_Home !== "-" && (
                  <span className="cfp-rank-badge">{item.CFP_Rank_Home}</span>
                )}
              </div>
            </div>
            <div className="weather-icon-wrapper" style={{ display: 'flex', alignItems: 'center' }}>{renderWeatherIcon(item)}</div>
            <div className="projections">
            <div className="values">
              {itemValueAway > 0 ? <ValueIndicator value={itemValueAway} item={item} isHome={false} /> : <div>&nbsp;</div>}
              {itemValueHome > 0 ? <ValueIndicator value={itemValueHome} item={item} isHome={true} /> : <div>&nbsp;</div>}
            </div>
              <div className="actual-scores">
                <div className="away-score">{getScore(item, 'y')}</div>
                <div className="home-score">{getScore(item, 'x')}</div>
              </div>
              <div className="actual-scores">
                <div className="status">{item.status && item.status !== "NS" && item.status !== "Not Started" && item.status !== "TIMED" ? item.status !== "HT" && item.status !== "FT" && item.status !== "AOT" && item.status !== "AP" && item.status !== "AET"? item.status + "'" : item.status : ""}</div>
              </div>
              <div className="projected-scores">
                <div className="away-proj">{Math.round(parseFloat(getAdjustedProjections(item).away_proj))}</div>
                <div className="home-proj">{Math.round(parseFloat(getAdjustedProjections(item).home_proj))}</div>
              </div>
              <div className="ml">
                <div className="away-ml">{getML(item, 'y')}</div>
                <div className="home-ml">{getML(item, 'x')}</div>
              </div>
              <div className="values">
                <div>{item.Sport && item.Sport.includes("Soccer")? parseFloat(parseFloat(getAdjustedProjections(item).away_proj) + parseFloat(getAdjustedProjections(item).home_proj)).toFixed(1): parseInt(item.Spread_home) < 0 ? getOU(item) : item.Spread_home ? -item.Spread_home : ""}</div>
                <div>{item.Sport && item.Sport.includes("Soccer")? getML(item, 'draw') : parseInt(item.Spread_home) < 0 ? item.Spread_home ? item.Spread_home : "" : getOU(item)}</div>
              </div>
       <div className="values">
                {(() => {
                  const { Proj_Total: adjustedProjTotal } = getAdjustedValues(item);
                  return (
                    <>
                      {adjustedProjTotal && adjustedProjTotal.includes("Over") ? 
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          {((item.Sport.includes("MLB") || item.Sport.includes("NHL")) && 
                          (containsText(getGoalieConference(item, 'y'), "N/A") ||
                          getGoalieConference(item, 'y') === "Unknown (2.75)" || 
                          containsText(getGoalieConference(item, 'y'), "N/A") ||
                          getGoalieConference(item, 'x') === "Unknown (2.75)") ||
                          containsText(getLocation(item), "N/A")) ? 
                            <span className="orange-dot-up"></span> 
                            : <span className="gold-dot-up"></span>
                          }
                          <span style={{ fontSize: '0.8em', color: ((item.Sport.includes("MLB") || item.Sport.includes("NHL")) && 
                          (containsText(getGoalieConference(item, 'y'), "N/A") ||
                          getGoalieConference(item, 'y') === "Unknown (2.75)" || 
                          containsText(getGoalieConference(item, 'y'), "N/A") ||
                          getGoalieConference(item, 'x') === "Unknown (2.75)") ||
                          containsText(getLocation(item), "N/A")) ?  'var(--accent-error)' : 'var(--accent-gold)' }}>OV</span>
                        </div>
                        : <div>&nbsp;</div>}
                      {adjustedProjTotal && adjustedProjTotal.includes("Under") ?
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          {((item.Sport.includes("MLB") || item.Sport.includes("NHL")) && 
                          (containsText(getGoalieConference(item, 'y'), "N/A") ||
                          getGoalieConference(item, 'y') === "Unknown (2.75)" || 
                          containsText(getGoalieConference(item, 'y'), "N/A") ||
                          getGoalieConference(item, 'x') === "Unknown (2.75)") ||
                          containsText(getLocation(item), "N/A")) ? 
                            <span className="orange-dot-down"></span> 
                            : <span className="gold-dot-down"></span>
                          }
                          <span style={{ fontSize: '0.8em', color: ((item.Sport.includes("MLB") || item.Sport.includes("NHL")) && 
                          (containsText(getGoalieConference(item, 'y'), "N/A") ||
                          getGoalieConference(item, 'y') === "Unknown (2.75)" || 
                          containsText(getGoalieConference(item, 'y'), "N/A") ||
                          getGoalieConference(item, 'x') === "Unknown (2.75)") ||
                          containsText(getLocation(item), "N/A")) ? 'var(--accent-error)' : 'var(--accent-gold)' }}>UN</span>
                        </div>
                        : <div>&nbsp;</div>}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
          {isExpanded && (
            <div className="expanded-stats">
              <div className="team-expanded-stats">
                <div>{item.Logo_y && item.Logo_y.includes("https") ? (<img src={item.Logo_y} alt={item.Away} className="team-logo2" />) : (<><br/><br/></>)}</div>
                <div style={{ textDecoration: 'underline' }}>{item.Away ? item.Away : '-'}
                  {item.CFP_Rank_Away && item.CFP_Rank_Away !== "-" && (
                  <span className="cfp-rank-badge">{item.CFP_Rank_Away}</span>
                )}</div>
                <div>{getRecord(item, 'y')} {item.Away_leagueRank ? "(" + getRankSuffix(item.Away_leagueRank) + ")" : ""}</div>                
                <div>{getGoalieConference(item, 'y')}</div>
                <div>{Proj_ML_Away ? Proj_ML_Away: '-'}</div>
                {/* <div>{getPts(item, 'for', 'y').stat}</div> */}
                {/* <div>{getPts(item, 'ag', 'y').stat}</div> */}
                {/* <div>{getPassShoot(item, 'for', 'y')}</div>
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) ? getPassShoot(item, 'ag', 'y') : ""}</div>
                <div>{getRushEffPP(item, 'for', 'y')}</div>
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) ? getRushEffPP(item, 'ag', 'y') : ""}</div>    
                <div>{getPenPacePK(item, 'for', 'y')}</div>           
                <div>{getGiveMargFO(item, 'for', 'y')}</div>
                <div>{getTake(item, 'for', 'y')}</div> */}
                {/* <div>{item.Rating_FPI_y ? item.Rating_FPI_y + ((parseFloat(item.Rating_FPI_y) - getHomeAdv(item.Sport) - parseFloat(item.Rating_FPI_x)) > 0 ? " (" + parseFloat(parseFloat(item.Rating_FPI_y) - getHomeAdv(item.Sport) - parseFloat(item.Rating_FPI_x)).toFixed(1) + ")": ""): '-'}</div> */}
                {/* <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB")) ? getBye(item, 'for', 'y') : ""}</div>  */}
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB")) ? getConfRec(item, 'y') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL")) ? getATS(item, 'y') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB")) ? getRecordAt(item, 'y') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL")) ? getRecordAs(item, 'y') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("MLB"))? getOURecordAt(item, 'y') : ""}</div>  
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL")) ? getOURecord(item, 'y') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("NBA") || item.Sport.includes("NHL")) ? getRestRec(item, 'y') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("NBA")) ? getOURestRec(item, 'y') : ""}</div> 
                <div>{item.Sport.includes("Soccer") ? getForm(item, 'y') : ""}</div>
                <div>{getInj(item, 'y')}</div>
              </div>
              <div className="team-expanded-header">
                
                <div>{item.status && item.status !== "Not Started" && item.status !== "NS" && item.status !== "TIMED" ? <><span className="score-display">{getScore(item, 'y') + " : " + getScore(item, 'x')}</span><br /><div style={{ lineHeight: '1.15em', color: '#c7c7b1'  }}>{item.status}</div></> : (<div style={{ lineHeight: '1.9' }}><><br /><br /></></div>)}</div>
                <div style={{ textDecoration: 'underline' }}>Team</div>
                <div>Record</div>
                <div>{item.Sport && item.Sport.includes("NHL") ? "Starting Goalie" : item.Sport.includes("MLB") ? <>Starting Pitcher<br /> Starter Rec ERA<br /></> : ""}</div>
                <div>{item.Sport && (item.Sport.includes("NHL") || item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("Soccer")) ? "Conference" : ""}</div>
                <div>Proj ML</div>
                {/* <div>Pts For</div>  
                <div>Pts Against</div>  
                <div>{item.Sport && item.Sport.includes("NHL") ? "Shots (% Ag)" : item.Sport.includes("NBA") || item.Sport.includes("CBB") ? "Shooting" :  item.Sport.includes("NFL") || item.Sport.includes("CFB") ? "Pass Yds" : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) ? "Pass Yds Ag" : ""}</div>
                <div>{item.Sport && item.Sport.includes("NHL") ? "PP" : item.Sport.includes("NBA") || item.Sport.includes("CBB") ? "Def Eff" : item.Sport.includes("Soccer") || item.Sport.includes("MLB") ? "" :"Rush Yds"}</div>   
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) ? "Rush Yds Ag" : ""}</div>
                <div>{item.Sport && item.Sport.includes("NHL") ? "PK" : item.Sport.includes("NBA") || item.Sport.includes("CBB") ? "Pace" : item.Sport.includes("Soccer") || item.Sport.includes("MLB")? "" :"Penalty Yds"}</div> 
                <div>{item.Sport && item.Sport.includes("NHL") ? "Faceoff" : item.Sport.includes("NBA") || item.Sport.includes("CBB") ? "Steals" : item.Sport.includes("Soccer") || item.Sport.includes("MLB")? "" :"Giveaways"}</div>  
                <div>{item.Sport && item.Sport.includes("NHL") ? "Hits (Diff)" : item.Sport.includes("NBA") || item.Sport.includes("CBB") ? "Margin" : item.Sport.includes("Soccer") || item.Sport.includes("MLB")? "" :"Takeaways"}</div> */}
                {/* <div>PI</div> */} 
                {/* <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) ? "Bye Week" : (item.Sport.includes("NBA") || item.Sport.includes("CBB")) ? "Avg Lead" :""}</div>     */}
                <div>{item.Sport && (item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB"))? ((item.Conference_x || item.home_conference) === (item.Conference_y || item.away_conference) ? "ATS Conf Rec" : "ATS Non-Conf" ) : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL")) ? ((item.home_conference + item.home_division) === (item.away_conference + item.away_division) ? "ATS Conf Rec" : "ATS Non-Conf" ) : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL"))? (item.Sport.includes("MLB") || item.Sport.includes("NHL")) ? "Rec at Loc" : "ATS Record" : ""}</div>       
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB")) ? "ATS Rec at Loc" : ""}</div>              
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL"))? item.Sport.includes("MLB") ? "Record As" : "ATS Record As" : ""}</div>    
                <div>{item.Sport && (item.Sport.includes("MLB"))? "O/U at Loc" : ""}</div>    
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL")) ? "OU Rec" : ""}</div>
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("NBA") || item.Sport.includes("NHL")) ? item.Sport.includes("NHL") ? "Days Rest" : "L3 Rest Rec (Days)" : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("NBA") ) ? "L3 OU Rest Rec (Days)" : ""}</div>
                <div>{item.Sport.includes("Soccer") ? "Form" : "Injury"}</div>   
                <div>{item.Sport.includes("Soccer") ? <span style={{ textDecoration: 'underline' }}>L6 OU (GPG)</span> : ""}</div>
                <div>{item.Sport.includes("Soccer") ? getForm(item, 'h2h') : ""}</div>  
                <div>{item.Sport.includes("Soccer") ? "Injury" : ""}</div> 
                <div><><br/>{getLocation(item)}</></div>
                {(itemValueAway > 0 || itemValueHome > 0 || adjustedProjTotal.includes("Over") || adjustedProjTotal.includes("Under")) && (
                  <div className="analysis-output">
                    <div className="analysisbody2">{getRecommendation(item)}</div>
                  </div>
                )}
              </div>
              <div className="team-expanded-stats">
              <div>{item.Logo_x && item.Logo_x.includes("https") ? (<img src={item.Logo_x} alt={item.Home} className="team-logo2" />) : (<><br/><br/></>)}</div>
                <div style={{ textDecoration: 'underline' }}>{item.Home ? item.Home: '-'}                  
                  {item.CFP_Rank_Home && item.CFP_Rank_Home !== "-" && (
                  <span className="cfp-rank-badge">{item.CFP_Rank_Home}</span>
                )}</div>
                <div>{getRecord(item, 'x')} {item.Home_leagueRank ? "(" + getRankSuffix(item.Home_leagueRank) + ")" : ""}</div>
                <div>{getGoalieConference(item, 'x')}</div>
                <div>{Proj_ML_Home ? Proj_ML_Home: '-'}</div>
                {/* <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${getPts(item, 'for', 'y').percentage}%` }}
                  ></div>
                </div> */}
                {/* <div>{getPts(item, 'for', 'x').stat}</div> */}
                {/* <div>{getPts(item, 'ag', 'x').stat}</div>
                <div>{getPassShoot(item, 'for', 'x')}</div>
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) ? getPassShoot(item, 'ag', 'x') : ""}</div>
                <div>{getRushEffPP(item, 'for', 'x')}</div>
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB")) ? getRushEffPP(item, 'ag', 'x') : ""}</div>
                <div>{getPenPacePK(item, 'for', 'x')}</div> */}
                {/* <div>{getGiveMargFO(item, 'for', 'x')}</div>
                <div>{getTake(item, 'for', 'x')}</div> */}
                {/* <div>{item.Rating_FPI_x ? item.Rating_FPI_x + ((parseFloat(item.Rating_FPI_x) + getHomeAdv(item.Sport) - parseFloat(item.Rating_FPI_y)) > 0 ? " (" + parseFloat(parseFloat(item.Rating_FPI_x) + getHomeAdv(item.Sport) - parseFloat(item.Rating_FPI_y)).toFixed(1) + ")": ""): '-'}</div> */}
                {/* <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB")) ? getBye(item, 'for', 'x') : ""}</div>  */}
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB")) ? getConfRec(item, 'x') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL")) ? getATS(item, 'x') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("NHL")) ? getRecordAt(item, 'x') : ""}</div>
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL")) ? getRecordAs(item, 'x') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("MLB"))? getOURecordAt(item, 'x') : ""}</div>  
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("CFB") || item.Sport.includes("NBA") || item.Sport.includes("CBB") || item.Sport.includes("MLB") || item.Sport.includes("NHL")) ? getOURecord(item, 'x') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("NBA") || item.Sport.includes("NHL")) ? getRestRec(item, 'x') : ""}</div> 
                <div>{item.Sport && (item.Sport.includes("NFL") || item.Sport.includes("NBA")) ? getOURestRec(item, 'x') : ""}</div> 
                <div>{item.Sport.includes("Soccer") ? getForm(item, 'x') : ""}</div>
                <div>{getInj(item, 'x')}</div>
              </div>
            </div>
          )} 
          
          {isExpanded && (
            <div className="expanded-stats">
              <div className="grid-item-container" style={{ border: "none" }}>
                <div className="handle-output">
                  <div className="handle-title">Moneyline Handle</div>

                  <div className="handle-row">
                    {getHandleBar(
                      item,
                      "moneyline",
                      "away_pct",
                      "home_pct",
                      getInitials(item.Away),
                      getInitials(item.Home)
                    )}
                  </div>

                  <div className="handle-title">Total Handle</div>

                  <div className="handle-row">
                    {getHandleBar(
                      item,
                      "total",
                      "home_pct",
                      "away_pct",
                      "UN",
                      "OV"
                    )}
                  </div>
                </div>    
          <div className="injury-output">
            <div className="injury-details-title">Key Injuries</div>
            <div className="injury-details-row">
              <div className="injury-detail-column">{getInjDetail(item, 'y')}</div>
              <div className="injury-detail-column">{getInjDetail(item, 'x')}</div>
            </div>
          </div>
          <StatsMatch statistics={statistics} isDarkMode={false} onStatisticClick={(stat) => {
            setSituationAnalysisData({
              ...item,
              location: stat.location,
              type: stat.type,
            });
            setShowSituationAnalysis(true);
          }} />

          <button
            className="generate-analysis-btn"
            // onClick={() => fetchAnalysisPrompt(item)}
              disabled={
                analysisLoading ||
                !!item.analysis ||
                true || // Disable button for mongodb issues **************
                !(
                  item.Time &&
                  (() => {
                    // Extract MM/DD/YYYY from item.Time
                    const timeParts = item.Time.split(" ");
                    // timeParts[1] = MM/DD/YYYY
                    const itemDateStr = timeParts[1];
                    // Format today's date as MM/DD/YYYY
                    const todayDateStr = `${String(today.getMonth() + 1).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}/${today.getFullYear()}`;
                    return itemDateStr === todayDateStr;
                  })()
                )
              }
          >
            {analysisLoading
              ? "Generating..."
              : item.analysis
              ? "Analysis Found"
              : !(
                  item.Time &&
                  (() => {
                    const timeParts = item.Time.split(" ");
                    const itemDateStr = timeParts[1];
                    const todayDateStr = `${String(today.getMonth() + 1).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}/${today.getFullYear()}`;
                    return itemDateStr === todayDateStr;
                  })()
                )
              ? "Analyze on Gameday"
              : "Generate Analysis"}
          </button>
      {(item.analysis || analysisOutput) && (
        <div className="analysis-output">
          <h5>Analysis:</h5>
          <div className="analysisbody">{item.analysis || analysisOutput}</div>
        </div>
      )}
      </div>
      </div>)}    
      </div>
      );
    });
  };

  // Run Line Calculator Functions
  const calculateRunLine = () => {
    const { amount, moneyline, runline } = runLineData;
    
    if (!amount || !moneyline || !runline) return null;

    const T = parseFloat(amount); // Target profit
    const mlOdds = parseFloat(moneyline); // ML odds (can be positive or negative)
    const rlOdds = parseFloat(runline); // Runline odds (can be positive or negative)
    
    // Validate inputs
    if (T <= 0) return null;
    
    // Define profit factors using universal formula
    const profitFactor = (odds) => {
      if (odds > 0) {
        return odds / 100;
      } else if (odds < 0) {
        return 100 / Math.abs(odds);
      }
      return 0;
    };
    
    const alpha = profitFactor(mlOdds); // α = profit per $1 on ML
    const beta = profitFactor(rlOdds);  // β = profit per $1 on -1.5
    
    // Validate profit factors
    if (alpha <= 0 || beta <= 0) return null;
    
    // Stakes to place (universal formulas)
    const mlStake = T / (alpha * (1 + beta)); // x = T / (α(1 + β))
    const runlineStake = T / (1 + beta);      // y = T / (1 + β)
    
    // Calculate profits for each bet
    const mlProfit = alpha * mlStake;         // ML profit when it wins
    const runlineProfit = beta * runlineStake; // Runline profit when it wins
    
    // Total risk
    const totalRisk = mlStake + runlineStake; // R = x + y
    
    // Profit-to-risk ratio
    const q = (alpha * (1 + beta)) / (1 + alpha); // q = α(1 + β) / (1 + α)
    
    // Convert q to American odds
    let createdOdds;
    if (q >= 1) {
      createdOdds = `+${Math.round(100 * q)}`;
    } else {
      createdOdds = `-${Math.round(100 / q)}`;
    }

    return {
      wager1: {
        toWin: T,
        wagerNum: 1,
        odds: mlOdds,
        risk: mlStake.toFixed(2),
        win: mlProfit.toFixed(2)
      },
      wager2: {
        toWin: T,
        wagerNum: 2,
        odds: rlOdds,
        risk: runlineStake.toFixed(2),
        win: runlineProfit.toFixed(2)
      },
      createdOdds,
      totalRisk: totalRisk.toFixed(2),
      profitFactors: {
        alpha: alpha.toFixed(4),
        beta: beta.toFixed(4),
        q: q.toFixed(4)
      },
      scenarios: {
        winBy1: {
          description: "Win by exactly 1 run",
          profit: (mlProfit - runlineStake).toFixed(2) // Should be 0
        },
        winBy2Plus: {
          description: "Win by 2+ runs", 
          profit: (mlProfit + runlineProfit).toFixed(2) // Should equal T
        },
        lose: {
          description: "Lose",
          loss: totalRisk.toFixed(2)
        }
      }
    };
  };

  const handleRunLineInputChange = (field, value) => {
    setRunLineData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Sort sports by number of children (games) before rendering
  const sportsOrder = ["MLB", "NBA", "NHL", "Soccer", "NFL", "CFB", "CBB"];
  const sportsWithCounts = sportsOrder.map(section => ({
    name: section,
    count: model?.[`${section.toLowerCase()}Bets`]?.length || 0
  }));
  const sortedSports = sportsWithCounts
    .sort((a, b) => b.count - a.count)
    .map(s => s.name);

  const { baseType, suffix, oppsuffix } = situationAnalysisData && situationAnalysisData.type 
    ? getAnalysisKey(situationAnalysisData.type, situationAnalysisData.location)
    : { baseType: '', suffix: '', oppsuffix: '' };

  return (
    <div className="bets-page">
      {/* schedule Header */}
      <div className="top-header-header-model">
        <div className="top-header-title">
          <Cpu className="top-header-icon" />
          <div>
            <h1>Model</h1>
          </div>
        </div>
        <p className="top-header-subtitle">
          Research upcoming games and view detailed statistics to make informed betting decisions.
        </p>
      </div>
      <div className="calendar-header">
        <h3>Select Date:</h3>
        <button onClick={() => setSelectedDate(new Date(selectedDate.setDate(selectedDate.getDate() - 1)))}>▼</button>
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          dateFormat="MM/dd/yy"
          className="date-picker"
        />
      <button onClick={() => setSelectedDate(new Date(selectedDate.setDate(selectedDate.getDate() + 1)))}>▲</button>
      <button onClick={() => setSelectedDate(new Date(today))}>x</button>
      </div>
  
      {/* Impact Adjustment Sliders */}
    <div className="impact-sliders-container">
      {/* <h3>Adjust Impact Weights</h3> */}
      <div className="sliders-grid">
        <div className="slider-group">
          <label>Conviction: <span className="slider-value">{(impactWeights.convictionLimit/100).toFixed(1)}</span></label>
          <input 
            type="range" 
            min="1" 
            max="500" 
            value={impactWeights.convictionLimit}
            onChange={(e) => handleSliderChange('convictionLimit', e.target.value)}
            className="impact-slider"
          />
        </div>
        {/* <div className="slider-group">
          <label>Stats: <span className="slider-value">{impactWeights.stats}%</span></label>
          <input 
            type="range" 
            min="0" 
            max="100" 
            value={impactWeights.stats}
            onChange={(e) => handleSliderChange('stats', e.target.value)}
            className="impact-slider"
          />
        </div>
        
        <div className="slider-group">
          <label>Location: <span className="slider-value">{impactWeights.location}%</span></label>
          <input 
            type="range" 
            min="0" 
            max="100" 
            value={impactWeights.location}
            onChange={(e) => handleSliderChange('location', e.target.value)}
            className="impact-slider"
          />
        </div>
        
        <div className="slider-group">
          <label>Weather: <span className="slider-value">{impactWeights.weather}%</span></label>
          <input 
            type="range" 
            min="0" 
            max="100" 
            value={impactWeights.weather}
            onChange={(e) => handleSliderChange('weather', e.target.value)}
            className="impact-slider"
          />
        </div>

        <div className="slider-group">
          <label>Injury: <span className="slider-value">{impactWeights.injury}%</span></label>
          <input 
            type="range" 
            min="0" 
            max="100" 
            value={impactWeights.injury}
            onChange={(e) => handleSliderChange('injury', e.target.value)}
            className="impact-slider"
          />
        </div> */}

        {/* <div className="slider-group" style={{width: '60px', alignSelf: 'center', paddingTop: '0.25rem' }}>
          <button 
                        onClick={() => setImpactWeights({ stats: 50, location: 50, weather: 50, injury: 50, convictionLimit: 100 })}
            style={{
              padding: '6px 6px',
              backgroundColor: 'var(--accent-gold)',
              color: 'var(--bg-primary)',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '0.8em'
            }}
          >
            Reset
          </button>
        </div> */}
      </div>
    </div>



      {/* Results Summary Box */}
      <div className="results-summary-box">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <h3>Results</h3>
          <h3>
          <button 
            onClick={() => setShowHistoricRecord(!showHistoricRecord)}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--accent-gold)',
              cursor: 'pointer',
              fontSize: '0.9em',
              textDecoration: 'underline',
              padding: 0
            }}
          >
            {showHistoricRecord ? 'View Daily Best Bet Results' : 'View All Games Record'}
          </button></h3>
        </div>
        <div className="results-grid">
          {showHistoricRecord ? (
            // Historic record display
            <div className="results-item" style={{ gridColumn: '1 / -1', textAlign: 'center' }}>
              <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                <div>
                  <span style={{ color: '#2d5a2d', fontWeight: 'bold', fontSize: '1.1em' }}>
                    {historicRecord.wins}W
                  </span>
                </div>
                <div>
                  <span style={{ color: '#5a2d2d', fontWeight: 'bold', fontSize: '1.1em' }}>
                    {historicRecord.losses}L
                  </span>
                </div>
                <div>
                  <span style={{ color: 'var(--accent-gold)', fontWeight: 'bold', fontSize: '1.1em' }}>
                    {historicRecord.pushes}P
                  </span>
                </div>
                <div>
                  <span style={{ color: 'var(--text-primary)', fontWeight: 'bold', fontSize: '1.1em' }}>
                    {historicRecord.wins + historicRecord.losses > 0 
                      ? `${Math.round((historicRecord.wins / (historicRecord.wins + historicRecord.losses)) * 100)}%`
                      : '-'
                    }
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* Total Row - Display First */}
              {(() => {
                let totalWins = 0;
                let totalBets = 0;
                sortedSports.forEach(section => {
                  const resultsText = getResultsText(model?.[`${section.toLowerCase()}Bets`] || []);
                  if (resultsText) {
                    const [wins, total] = resultsText.split('/').map(Number);
                    totalWins += wins || 0;
                    totalBets += total || 0;
                  }
                });
                const winPercentage = totalBets > 0 ? Math.round((totalWins / totalBets) * 100) : 0;
                const bgColor = winPercentage > 50 ? '#2d5a2d' : winPercentage < 50 ? '#5a2d2d' : 'var(--accent-very-light)';
                return totalBets > 0 ? (
                  <div className="results-item" style={{ fontWeight: 'bold', backgroundColor: bgColor }}>
                    <span className="results-sport">TOTAL</span>
                    <span className="results-count">{totalWins}/{totalBets} ({winPercentage}%)</span>
                  </div>
                ) : null;
              })()}
              
              {/* Individual Sports */}
              {sortedSports.map((section) => {
                const resultsText = getResultsText(model?.[`${section.toLowerCase()}Bets`] || []);
                return resultsText ? (
                  <div key={section} className="results-item">
                    <span className="results-sport">{section}</span>
                    <span className="results-count">{resultsText}</span>
                  </div>
                ) : null;
              })}
            </>
          )}
        </div>
      </div>

      {/* Render Sections */}
      {sortedSports.map((section) => (
        <React.Fragment key={section}>
          <h3
            className="bet-header"
            onClick={() => handleToggleSection(section)}>
            {section} {collapsedSections[section] ? "▲" : "▼"}
            <span style={{ marginLeft: '12px', fontSize: '0.9em', fontWeight: 'normal' }}>
              {getResultsText(model?.[`${section.toLowerCase()}Bets`] || [])}
            </span>
          </h3>
          {!collapsedSections[section] && (
            <>
              <div className="grid-container">
                {renderGridRows(model?.[`${section.toLowerCase()}Bets`] || [], section)}
              </div>
              {/* AdSense Ad as last child in each sports section */}
              {/* <AdSenseAd 
                slot={`${section.toLowerCase()}-schedule-ad`}
                style={{ width: '100%', height: '10px' }}
              /> */}
            </>
          )}
        </React.Fragment>
      ))}
      
      {/* Floating Calculator Button */}
      <button 
        className="floating-calculator-btn"
        onClick={() => setShowRunLineCalculator(true)}
        title="Run Line Calculator"
      >
        <Key size={24} />
      </button>

      <button
      className="floating-calculator-btn2"
      onClick={() => setShowParlayCalculator(true)}
      title="Parlay Calculator"
      >
        <Layers size={24} />
      </button>

      {/* Run Line Calculator Modal */}
      {showRunLineCalculator && (
        <div className="modal-overlay" onClick={() => setShowRunLineCalculator(false)}>
          <div className="runline-calculator-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Run Line Calculator</h3>
              <button 
                className="close-modal-btn"
                onClick={() => setShowRunLineCalculator(false)}
              >
                <X size={20} />
              </button>
            </div>
            
            <div className="calculator-inputs">
              <div className="input-group2">
                <label>Amount</label>
                <input
                  type="number"
                  placeholder="Amount"
                  value={runLineData.amount}
                  onChange={(e) => handleRunLineInputChange('amount', e.target.value)}
                />
              </div>
              
              <div className="input-group2">
                <label>Moneyline</label>
                <input
                  type="number"
                  placeholder="Moneyline"
                  value={runLineData.moneyline}
                  onChange={(e) => handleRunLineInputChange('moneyline', e.target.value)}
                />
              </div>
              
              <div className="input-group2">
                <label>Run Line</label>
                <input
                  type="number"
                  placeholder="-1.5 Runline"
                  value={runLineData.runline}
                  onChange={(e) => handleRunLineInputChange('runline', e.target.value)}
                />
              </div>
            </div>

            {runLineData.amount && runLineData.moneyline && runLineData.runline && (
              <div className="calculator-results">
                <table className="results-table">
                  <thead>
                    <tr>
                      <th>To Win Amount</th>
                      <th>Wager Number</th>
                      <th>Odds</th>
                      <th>Amount To Risk</th>
                      <th>Amount To Win</th>
                    </tr>
                                   </thead>
                  <tbody>
                    {(() => {
                      const results = calculateRunLine();
                      if (!results) return null;
                      
                      return (
                        <>
                          <tr>
                            <td>{results.wager1.toWin}</td>
                            <td>{results.wager1.wagerNum}</td>
                            <td>{results.wager1.odds}</td>
                            <td>{results.wager1.risk}</td>
                            <td>{results.wager1.win}</td>
                          </tr>
                          <tr>
                            <td>{results.wager2.toWin}</td>
                            <td>{results.wager2.wagerNum}</td>
                            <td>{results.wager2.odds}</td>
                            <td>{results.wager2.risk}</td>
                            <td>{results.wager2.win}</td>
                          </tr>
                        </>
                      );
                    })()}
                  </tbody>
                </table>
                
                {(() => {
                  const results = calculateRunLine();
                  if (!results) return null;
                  
                  return (
                    <div className="created-odds">
                      <strong>Odds on Created -1/+1 Line: {results.createdOdds}</strong>
                      <div><strong>Total Risk: {results.totalRisk}</strong></div>
                    </div>
                  );
                })()}
              </div>
            )}
          </div>
        </div>
      )}

      {showParlayCalculator && (
      <div className="modal-overlay" onClick={() => setShowParlayCalculator(false)}>
        <div className="runline-calculator-modal" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Parlay Calculator</h3>
              <button
              className="close-modal-btn"
              // style={{ marginLeft: 8 }}
              onClick={handleParlayRefresh}
              // title="Clear All"
            >
              ⟳
            </button>
            <button
              className="close-modal-btn"
              onClick={() => setShowParlayCalculator(false)}
            >
              ×
            </button>
          </div>
          <div className="calculator-inputs">
            {parlayOdds.map((odds, idx) => (
              <div className="input-group2" key={idx}>
                <label>Leg {idx + 1} Odds</label>
                <input
                  type="number"
                  placeholder="e.g. -120 or 150"
                  value={odds}
                  onChange={e => handleParlayOddsChange(idx, e.target.value)}
                />
              </div>
            ))}
            <button
              style={{marginTop: 8}}
              onClick={addParlayLeg}
            >
              + Add Leg
            </button>
          </div>
          {parlayOdds.filter(o => o !== "").length >= 2 && (
            <div className="calculator-results">
              {(() => {
                const result = calcParlayImpliedOdds(parlayOdds);
                if (!result) return null;
                return (
                  <div className="created-odds">
                    <div>Implied Probability: <b>{result.impliedProb}%</b></div>
                    <div>Parlay American Odds: <b>{result.american > 0 ? `+${result.american}` : result.american}</b></div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      </div>
    )}
  
    {/* Situation Analysis Modal */}
    {showSituationAnalysis && situationAnalysisData && (
      <div className="modal-overlay" onClick={() => setShowSituationAnalysis(false)}>
        <div className="similar-games-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Situation Analysis: {situationAnalysisData.location.charAt(0).toUpperCase() + situationAnalysisData.location.slice(1)} {situationAnalysisData.type}</h3>
            <button 
              className="close-modal-btn"
              onClick={() => handleCloseSituationAnalysis()}
            >
              <X size={20} />
            </button>
          </div>
          <div className="situation-analysis-content">
            <div className="analysis-row">
              <div>
                <span><team>{situationAnalysisData.location === 'home' ? <><img src={situationAnalysisData['Logo_x']} alt="" className="situation-team-logo" /></> : <><img src={situationAnalysisData['Logo_y']} alt="" className="situation-team-logo" /></>}</team></span>
                <span><team>{situationAnalysisData.location === 'home' ? situationAnalysisData['Home'] : situationAnalysisData['Away'] || 'N/A'}</team></span>
              </div>
              </div>             
              <div className="analysis-row">
                <div>
                  <strong>Season:</strong>
                  <span>{situationAnalysisData[`${year}_${baseType}`]?.[suffix] ? parseFloat(situationAnalysisData[`${year}_${baseType}`]?.[suffix]).toFixed(1) : situationAnalysisData[`${year}_${baseType}_${suffix}`] ? parseFloat(situationAnalysisData[`${year}_${baseType}_${suffix}`]).toFixed(1) : situationAnalysisData[`${baseType}_${suffix}`] ? parseFloat(situationAnalysisData[`${baseType}_${suffix}`]).toFixed(1) : 'N/A'}</span>
                </div>
                <div>
                  <strong>Away:</strong>
                  <span>{situationAnalysisData[`Away_${baseType}`]?.[suffix] ? parseFloat(situationAnalysisData[`Away_${baseType}`]?.[suffix]).toFixed(1) : situationAnalysisData[`Away_${baseType}_${suffix}`] ? parseFloat(situationAnalysisData[`Away_${baseType}_${suffix}`]).toFixed(1) : 'N/A'}</span>
                </div>
                <div>
                  <strong>Last 3:</strong>
                  <span>{situationAnalysisData[`Last 3_${baseType}`]?.[suffix] ? parseFloat(situationAnalysisData[`Last 3_${baseType}`]?.[suffix]).toFixed(1) : situationAnalysisData[`Last 3_${baseType}_${suffix}`] ? parseFloat(situationAnalysisData[`Last 3_${baseType}_${suffix}`]).toFixed(1) : 'N/A'}</span>
                </div>
                <div>
                  <strong>Last 1:</strong>
                  <span>{situationAnalysisData[`Last 1_${baseType}`]?.[suffix] ? parseFloat(situationAnalysisData[`Last 1_${baseType}`]?.[suffix]).toFixed(1) : situationAnalysisData[`Last 1_${baseType}_${suffix}`] ? parseFloat(situationAnalysisData[`Last 1_${baseType}_${suffix}`]).toFixed(1) : 'N/A'}</span>
                </div>
              </div>
            <div className="analysis-row">
            {(() => {
              const isHome = suffix.endsWith('x');
              let filteredGames = similarGames;
              
              if (considerOpponent && situationAnalysisData) {
                const opponentStat = situationAnalysisData[`${year}_${baseType}`]?.[oppsuffix] || situationAnalysisData[`${year}_${baseType}_${oppsuffix}`] || parseFloat(situationAnalysisData[`${baseType}_${oppsuffix}`]);
                const multi = Math.abs(opponentStat) < 2 ? situationAnalysisData.Sport === "NBA" || situationAnalysisData.Sport === "CBB" ? 0.005 : 0.2 : 0.03;
                filteredGames = similarGames.filter(game => {
                  const gameOpponentStat = game[`${year}_${baseType}`]?.[oppsuffix] || game[`${year}_${baseType}_${oppsuffix}`] || parseFloat(game[`${baseType}_${oppsuffix}`]);
                  return gameOpponentStat && Math.abs(gameOpponentStat - opponentStat) < Math.abs(opponentStat) * multi;
                });
              }
              
              const spreadCovers = filteredGames.filter(game => {
                const homeScore = parseFloat(game.score_x);
                const awayScore = parseFloat(game.score_y);
                const spread = parseFloat(game.Spread_home) || -0.5;
                if (!isNaN(homeScore) && !isNaN(awayScore) && !isNaN(spread)) {
                  const homeSpreadscore = homeScore + spread;
                  const homeCovered = homeSpreadscore > awayScore;
                  return isHome ? homeCovered : !homeCovered;
                }
                return false;
              }).length;
              
              const total = filteredGames.length;
              
              return (
                <>
                  <div style={{ gridColumn: '1 / -1' , fontSize: '1em', fontWeight: 'bold', marginTop: '10px' }}>
                    <>Similar Situation Games</>
                    <div style={{ 
                      padding: '12px', 
                      backgroundColor: 'var(--bg-primary)',
                      borderRadius: '8px',
                      marginBottom: '16px',
                      border: '1px solid var(--border-primary)'
                    }}>
                {(() => {               
                  return (
                    <>
                      <strong>Spread ({isHome ? 'Home' : 'Away'}):</strong> {spreadCovers}/{total} ({total > 0 ? ((spreadCovers / total) * 100).toFixed(1) : 0}%)
                    </>
                  );
                })()}
                <br />
              <strong>Overs:</strong> {(() => {
                const overGames = filteredGames.filter(game => {
                  const homeScore = parseFloat(game.score_x);
                  const awayScore = parseFloat(game.score_y);
                  const ouLine = parseFloat(game["O/U"]) ? parseFloat(game["O/U"]) : game.Sport === "Soccer" ? 2.5 : "N/A";
                  if (!isNaN(homeScore) && !isNaN(awayScore) && !isNaN(ouLine)) {
                    return homeScore + awayScore >= ouLine;
                  }
                  return false;
                });
                const avgTotal = filteredGames.length > 0 ? (filteredGames.reduce((sum, game) => sum + parseFloat(game.score_x) + parseFloat(game.score_y), 0) / filteredGames.length).toFixed(1) : 0;
                return `${overGames.length}/${filteredGames.length} (${filteredGames.length > 0 ? ((overGames.length / filteredGames.length) * 100).toFixed(1) : 0}%) (avg ${avgTotal})`;
              })()}
                {/* Checkbox for considering opponent */}
                <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input 
                    type="checkbox" 
                    id="considerOpponent"
                    checked={considerOpponent}
                    onChange={(e) => setConsiderOpponent(e.target.checked)}
                  />
                  <label htmlFor="considerOpponent" style={{ margin: 0, color: 'var(--text-primary)' }}>
                    Consider Opponent Stats
                  </label>
                </div>
              </div>
              <table className="similar-games-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Home Team</th>
                    <th>Away Team</th>
                    <th>Score (H)</th>
                    <th>Score (A)</th>
                    <th>Spread</th>
                    <th>O/U</th>
                    <th>{suffix.replace("x", "h").replace("_y", "_a")}</th>
                    {considerOpponent && <th>{oppsuffix.replace("x","h").replace("_y","_a")}</th>}
                  </tr>
                </thead>
                <tbody>
                {filteredGames && filteredGames.length > 0 ? (
                  filteredGames.map((game, idx) => {
                    const homeScore = parseFloat(game.score_x);
                    const awayScore = parseFloat(game.score_y);
                    const spread = parseFloat(game.Spread_home) || -0.5;
                    const ouLine = parseFloat(game["O/U"]) ? parseFloat(game["O/U"]) : game.Sport === "Soccer" ? 2.5 : "N/A";
                    
                    // Determine which team covered
                    let homeCovered = false;
                    if (!isNaN(homeScore) && !isNaN(awayScore) && !isNaN(spread)) {
                      const homeSpreadscore = homeScore + spread;
                      homeCovered = homeSpreadscore > awayScore;
                    }
                    
                    let totalHitOver = false;
                    if (!isNaN(homeScore) && !isNaN(awayScore) && !isNaN(ouLine)) {
                      const total = homeScore + awayScore;
                      totalHitOver = total >= ouLine;
                    }

                    return (
                      <tr key={idx}>
                        <td>{game.Date?.split('/').slice(0, 2).join('/')}</td>
                        <td style={{ backgroundColor: homeCovered ? 'rgba(76, 175, 80, 0.3)' : 'transparent' }}>
                          {game.Home}
                        </td>
                        <td style={{ backgroundColor: !homeCovered ? 'rgba(76, 175, 80, 0.3)' : 'transparent' }}>
                          {game.Away}
                        </td>
                        <td>{game.score_x != null ? game.score_x : 'N/A'}</td>
                        <td>{game.score_y != null ? game.score_y : 'N/A'}</td>
                        <td>{game.Spread_home || 'N/A'}</td>
                        <td style={{ backgroundColor: totalHitOver ? 'rgba(76, 175, 80, 0.3)' : 'transparent' }}>
                          {parseFloat(game["O/U"]) ? parseFloat(game["O/U"]) : game.Sport === "Soccer" ? 2.5 : "N/A"}
                        </td>
                        <td>{parseFloat(situationAnalysisData[`${year}_${baseType}`]?.[suffix]) ? parseFloat(situationAnalysisData[`${year}_${baseType}`]?.[suffix]).toFixed(1) : parseFloat(game[`${year}_${baseType}_${suffix}`]) ? parseFloat(game[`${year}_${baseType}_${suffix}`]).toFixed(1) : parseFloat(game[`${baseType}_${suffix}`]) ? parseFloat(game[`${baseType}_${suffix}`]).toFixed(1) : 'N/A'}</td>
                        {considerOpponent && <td>{parseFloat(situationAnalysisData[`${year}_${baseType}`]?.[oppsuffix]) ? parseFloat(situationAnalysisData[`${year}_${baseType}`]?.[oppsuffix]).toFixed(1) : parseFloat(game[`${year}_${baseType}_${oppsuffix}`]) ? parseFloat(game[`${year}_${baseType}_${oppsuffix}`]).toFixed(1) : parseFloat(game[`${baseType}_${oppsuffix}`]) ? parseFloat(game[`${baseType}_${oppsuffix}`]).toFixed(1) : 'N/A'}</td>}
                      </tr>
                    );
                  })
                    ) : similarLoading ? (
                      <tr><td colSpan={considerOpponent ? "9" : "8"}>Loading similar games...</td></tr>
                    ) : (
                      <tr><td colSpan={considerOpponent ? "9" : "8"}>No similar games found</td></tr>
                    )}
                      </tbody>
                    </table>
                  </div>
                </>
              );
            })()}
            </div>
          </div>
        </div>
      </div>
    )}
    </div>
  );
}